webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataLoading_vue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67d4f007_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DataLoading_vue__ = __webpack_require__(395);
function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataLoading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67d4f007_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DataLoading_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ALERT_INFO */
/* unused harmony export ALERT_ERROR */
/* unused harmony export ALERT_EMPTY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_INIT_USERDATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_REFRESH_USERDATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_REFRESH_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FINANCE_REFRESH_RATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REGISTRATION_FILL_DATA; });
var ALERT_INFO = 'alert_info';
var ALERT_ERROR = 'alert_error';
var ALERT_EMPTY = 'alert_empty';

var USER_INIT_USERDATA = 'user__init_userdata';
var USER_REFRESH_USERDATA = 'user__refresh_userdata';
var USER_REFRESH_NOTIFICATIONS = 'user__refresh_notifications';

var FINANCE_REFRESH_RATE = 'finance__refresh_spd_rate';

var REGISTRATION_FILL_DATA = 'registration__fill_data';

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_133d7a89_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(349);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_133d7a89_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_381ed5ba_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(353);
function injectStyle (ssrContext) {
  __webpack_require__(351)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_381ed5ba_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7545215f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(424);
function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7545215f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_toastr_src_vue_toastr_scss__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_toastr_src_vue_toastr_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_toastr_src_vue_toastr_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__websanova_vue_auth_drivers_auth_bearer__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__websanova_vue_auth_drivers_auth_bearer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__websanova_vue_auth_drivers_auth_bearer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__websanova_vue_auth_drivers_http_axios_1_x__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__websanova_vue_auth_drivers_http_axios_1_x___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__websanova_vue_auth_drivers_http_axios_1_x__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websanova_vue_auth_drivers_router_vue_router_2_x__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websanova_vue_auth_drivers_router_vue_router_2_x___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__websanova_vue_auth_drivers_router_vue_router_2_x__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App_vue__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(465);



















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_5_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);

console.log(window.location.host);

if (window.location.host === 'localhost:8080') {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.defaults.baseURL = 'http://178.90.136.190:8000/api/';
} else {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.defaults.baseURL = 'https://api.profi-bank.org/api/';
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].router = __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth___default.a, {
    auth: __WEBPACK_IMPORTED_MODULE_8__websanova_vue_auth_drivers_auth_bearer___default.a,
    http: __WEBPACK_IMPORTED_MODULE_9__websanova_vue_auth_drivers_http_axios_1_x___default.a,
    router: __WEBPACK_IMPORTED_MODULE_10__websanova_vue_auth_drivers_router_vue_router_2_x___default.a,
    authRedirect: {
        name: 'AuthLogin'
    },
    loginData: {
        url: 'auth/login'
    },
    logoutData: {
        url: 'auth/logout'
    },
    fetchData: {
        url: 'auth/user'
    },
    refreshData: {
        url: 'auth/refresh'
    }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        var data = error.response.data;
        if (data.hasOwnProperty('message') && data.message !== 'Bad credentials') {
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].auth.logout();
        }
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    template: '<App/>',
    router: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */],
    components: { App: __WEBPACK_IMPORTED_MODULE_11__App_vue__["a" /* default */] }
});

app.$mount('#app');

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_group_vue__ = __webpack_require__(206);
function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_group_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */,
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_form_row__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_form_text__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_form_invalid_feedback__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_form_valid_feedback__ = __webpack_require__(96);










/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_2__mixins__["h" /* formStateMixin */]],
    components: { bFormRow: __WEBPACK_IMPORTED_MODULE_3__form_form_row__["a" /* default */], bFormText: __WEBPACK_IMPORTED_MODULE_4__form_form_text__["a" /* default */], bFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_5__form_form_invalid_feedback__["a" /* default */], bFormValidFeedback: __WEBPACK_IMPORTED_MODULE_6__form_form_valid_feedback__["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        var legend = h(false);
        if (t.label || $slots.label || t.horizontal) {
            legend = h('legend', { class: t.labelClasses, attrs: { id: t.labelId } }, [$slots.label || h('span', { domProps: { innerHTML: t.label || '' } })]);
        }

        var invalidFeedback = h(false);
        if (t.feedback || $slots['invalid-feedback'] || $slots['feedback']) {
            invalidFeedback = h('b-form-invalid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback']),
                    expression: "Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback'])"
                }],
                attrs: {
                    id: t.feedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === false ? $slots['invalid-feedback'] || $slots['feedback'] || h('span', { domProps: { innerHTML: t.feedback || '' } }) : h(false)]);
        }

        var validFeedback = h(false);
        if (t.validFeedback || $slots['valid-feedback']) {
            validFeedback = h('b-form-valid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.validFeedback || $slots['valid-feedback']),
                    expression: "Boolean(t.validFeedback || $slots['valid-feedback'])"
                }],
                attrs: {
                    id: t.validFeedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === true ? $slots['valid-feedback'] || h('span', { domProps: { innerHTML: t.validFeedback || '' } }) : h(false)]);
        }

        var description = h(false);
        if (t.description || $slots['description']) {
            description = h('b-form-text', { attrs: { id: t.descriptionId } }, [$slots['description'] || h('span', { domProps: { innerHTML: t.description || '' } })]);
        }

        var content = h('div', { ref: 'content', class: t.inputLayoutClasses }, [$slots.default, invalidFeedback, validFeedback, description]);

        return h('fieldset', {
            class: t.groupClasses,
            attrs: { id: t.safeId(), 'aria-describedby': t.describedByIds }
        }, [h('b-form-row', {}, [legend, content])]);
    },

    props: {
        horizontal: {
            type: Boolean,
            default: false
        },
        labelCols: {
            type: Number,
            default: 3,
            validator: function validator(value) {
                if (value >= 1 && value <= 11) {
                    return true;
                }
                Object(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* warn */])('b-form-group: label-cols must be a value between 1 and 11');
                return false;
            }
        },
        breakpoint: {
            type: String,
            default: 'sm'
        },
        labelTextAlign: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        labelSrOnly: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: null
        },
        feedback: {
            type: String,
            default: null
        },
        validFeedback: {
            type: String,
            default: null
        },
        validated: {
            type: Boolean,
            value: false
        }
    },
    computed: {
        inputState: function inputState() {
            return this.stateClass;
        },
        groupClasses: function groupClasses() {
            return ['b-form-group', 'form-group', this.validated ? 'was-validated' : null, this.inputState];
        },
        labelClasses: function labelClasses() {
            return [this.labelSrOnly ? 'sr-only' : 'col-form-legend', this.labelLayout, this.labelAlignClass];
        },
        labelLayout: function labelLayout() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.horizontal ? 'col-' + this.breakpoint + '-' + this.labelCols : 'col-12';
        },
        labelAlignClass: function labelAlignClass() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.labelTextAlign ? 'text-' + this.labelTextAlign : null;
        },
        inputLayoutClasses: function inputLayoutClasses() {
            return [this.horizontal ? 'col-' + this.breakpoint + '-' + (12 - this.labelCols) : 'col-12'];
        },
        labelId: function labelId() {
            return this.label || this.$slots['label'] ? this.safeId('_BV_label_') : null;
        },
        descriptionId: function descriptionId() {
            if (this.description || this.$slots['description']) {
                return this.safeId('_BV_description_');
            }
            return null;
        },
        feedbackId: function feedbackId() {
            if (this.feedback || this.$slots['invalid-feedback'] || this.$slots['feedback']) {
                return this.safeId('_BV_feedback_invalid_');
            }
            return null;
        },
        validFeedbackId: function validFeedbackId() {
            if (this.validFeedback || this.$slots['valid-feedback']) {
                return this.safeId('_BV_feedback_valid_');
            }
            return null;
        },
        describedByIds: function describedByIds() {
            return [this.labelId, this.descriptionId, this.computedState === false ? this.feedbackId : null, this.computedState === true ? this.validFeedbackId : null].filter(function (i) {
                return i;
            }).join(' ') || null;
        }
    }
});

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__(215);
function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(4);





var TYPES = ['text', 'password', 'email', 'number', 'url', 'tel', 'search', 'range', 'color', 'date', 'time', 'datetime', 'datetime-local', 'month', 'week'];

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["g" /* formSizeMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins__["h" /* formStateMixin */]],
    render: function render(h) {
        var t = this;
        return h('input', {
            ref: 'input',
            class: t.inputClass,
            domProps: { value: t.localValue },
            attrs: {
                id: t.safeId(),
                name: t.name,
                type: t.localType,
                disabled: t.disabled,
                required: t.required,
                readonly: t.readonly || t.plaintext,
                placeholder: t.placeholder,
                autocomplete: t.autocomplete || null,
                'aria-required': t.required ? 'true' : null,
                'aria-invalid': t.computedAriaInvalid
            },
            on: {
                input: t.onInput,
                change: t.onChange
            }
        });
    },
    data: function data() {
        return {
            localValue: this.value
        };
    },

    props: {
        value: {
            default: null
        },
        type: {
            type: String,
            default: 'text',
            validator: function validator(type) {
                return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(TYPES, type);
            }
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        plaintext: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        formatter: {
            type: Function
        },
        lazyFormatter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localType: function localType() {
            return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(TYPES, this.type) ? this.type : 'text';
        },
        inputClass: function inputClass() {
            return [this.plaintext ? 'form-control-plaintext' : 'form-control', this.plaintext ? 'w-100' : '', this.sizeFormClass, this.stateClass];
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (!Boolean(this.ariaInvalid) || this.ariaInvalid === 'false') {
                return this.computedState === false ? 'true' : null;
            }
            if (this.ariaInvalid === true) {
                return 'true';
            }

            return this.ariaInvalid;
        }
    },
    watch: {
        value: function value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localValue = newVal;
            }
        },
        localValue: function localValue(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        format: function format(value, e) {
            if (this.formatter) {
                var formattedValue = this.formatter(value, e);
                if (formattedValue !== value) {
                    return formattedValue;
                }
            }
            return value;
        },
        onInput: function onInput(evt) {
            var value = evt.target.value;
            if (this.lazyFormatter) {
                this.localValue = value;
            } else {
                this.localValue = this.format(value, evt);
            }
        },
        onChange: function onChange(evt) {
            this.localValue = this.format(evt.target.value, evt);
            this.$emit('change', this.localValue);
        },
        focus: function focus() {
            if (!this.disabled) {
                this.$el.focus();
            }
        }
    }
});

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__(222);
function injectStyle (ssrContext) {
  __webpack_require__(221)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_array__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["d" /* formMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["h" /* formStateMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins__["c" /* formCustomMixin */]],
    render: function render(h) {
        var t = this;

        var input = h('input', {
            ref: 'input',
            class: t.inputClasses,
            attrs: {
                type: 'file',
                id: t.safeId(),
                name: t.name,
                disabled: t.disabled,
                required: t.required,
                capture: t.capture || null,
                'aria-required': t.required ? 'true' : null,
                accept: t.accept || null,
                multiple: t.multiple,
                webkitdirectory: t.directory,
                'aria-describedby': t.plain ? null : t.safeId('_BV_file_control_')
            },
            on: {
                change: t.onFileChange,
                focusin: t.focusHandler,
                focusout: t.focusHandler
            }
        });

        if (t.plain) {
            return input;
        }

        var droptarget = h(false);
        if (t.dragging) {
            droptarget = h('span', {
                class: ['drop-here'],
                attrs: { 'data-drop': t.dropLabel },
                on: {
                    dragover: t.dragover,
                    drop: t.drop,
                    dragleave: t.dragleave
                }
            });
        }

        var labels = h('span', {
            class: ['custom-file-control', t.dragging ? 'dragging' : null],
            attrs: {
                id: t.safeId('_BV_file_control_'),
                'data-choose': t.computedChooseLabel,
                'data-selected': t.selectedLabel
            }
        });

        return h('label', {
            class: ['custom-file', 'b-form-file', t.stateClass, 'w-100', 'd-block'],
            attrs: { id: t.safeId('_BV_file_outer_') },
            on: { dragover: t.dragover }
        }, [droptarget, input, labels]);
    },
    data: function data() {
        return {
            selectedFile: null,
            dragging: false,
            hasFocus: false
        };
    },

    props: {
        accept: {
            type: String,
            default: ''
        },
        capture: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: null
        },
        chooseLabel: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        directory: {
            type: Boolean,
            default: false
        },
        noTraverse: {
            type: Boolean,
            default: false
        },
        selectedFormat: {
            type: String,
            default: ':count Files'
        },
        noDrop: {
            type: Boolean,
            default: false
        },
        dropLabel: {
            type: String,
            default: 'Drop files here'
        }
    },
    computed: {
        inputClasses: function inputClasses() {
            return [{
                'form-control-file': this.plain,
                'custom-file-input': this.custom,
                'w-100': true,
                'focus': this.custom && this.hasFocus
            }, this.stateClass];
        },
        selectedLabel: function selectedLabel() {
            if (!this.selectedFile || this.selectedFile.length === 0) {
                return this.placeholder || 'No file chosen';
            }
            if (this.multiple) {
                if (this.selectedFile.length === 1) {
                    return this.selectedFile[0].name;
                }
                return this.selectedFormat.replace(':names', this.selectedFile.map(function (file) {
                    return file.name;
                }).join(',')).replace(':count', this.selectedFile.length);
            }
            return this.selectedFile.name;
        },
        computedChooseLabel: function computedChooseLabel() {
            return this.chooseLabel || (this.multiple ? 'Choose Files' : 'Choose File');
        }
    },
    watch: {
        selectedFile: function selectedFile(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (!newVal && this.multiple) {
                this.$emit('input', []);
            } else {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        focusHandler: function focusHandler(evt) {
            if (this.plain || evt.type === 'focusout') {
                this.hasFocus = false;
            } else {
                this.hasFocus = true;
            }
        },
        reset: function reset() {
            try {
                this.$refs.input.value = '';
            } catch (e) {}

            this.$refs.input.type = '';
            this.$refs.input.type = 'file';
            this.selectedFile = this.multiple ? [] : null;
        },
        onFileChange: function onFileChange(evt) {
            var _this = this;

            this.$emit('change', evt);

            var items = evt.dataTransfer && evt.dataTransfer.items;
            if (items && !this.noTraverse) {
                var queue = [];
                for (var i = 0; i < items.length; i++) {
                    var item = items[i].webkitGetAsEntry();
                    if (item) {
                        queue.push(this.traverseFileTree(item));
                    }
                }
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(queue).then(function (filesArr) {
                    _this.setFiles(Object(__WEBPACK_IMPORTED_MODULE_2__utils_array__["c" /* from */])(filesArr));
                });
                return;
            }

            this.setFiles(evt.target.files || evt.dataTransfer.files);
        },
        setFiles: function setFiles(files) {
            if (!files) {
                this.selectedFile = null;
                return;
            }
            if (!this.multiple) {
                this.selectedFile = files[0];
                return;
            }

            var filesArray = [];
            for (var i = 0; i < files.length; i++) {
                if (files[i].type.match(this.accept)) {
                    filesArray.push(files[i]);
                }
            }
            this.selectedFile = filesArray;
        },
        dragover: function dragover(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop || !this.custom) {
                return;
            }
            this.dragging = true;
            evt.dataTransfer.dropEffect = 'copy';
        },
        dragleave: function dragleave(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            this.dragging = false;
        },
        drop: function drop(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop) {
                return;
            }
            this.dragging = false;
            if (evt.dataTransfer.files && evt.dataTransfer.files.length > 0) {
                this.onFileChange(evt);
            }
        },
        traverseFileTree: function traverseFileTree(item, path) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                path = path || '';
                if (item.isFile) {
                    item.file(function (file) {
                        file.$path = path;
                        resolve(file);
                    });
                } else if (item.isDirectory) {
                    item.createReader().readEntries(function (entries) {
                        var queue = [];
                        for (var i = 0; i < entries.length; i++) {
                            queue.push(_this2.traverseFileTree(entries[i], path + item.name + '/'));
                        }
                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(queue).then(function (filesArr) {
                            resolve(Object(__WEBPACK_IMPORTED_MODULE_2__utils_array__["c" /* from */])(filesArr));
                        });
                    });
                }
            });
        }
    }
});

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(239);
function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button_close__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dom__ = __webpack_require__(5);










var Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};

var OBSERVER_CONFIG = {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
};

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["i" /* idMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins__["j" /* listenOnRootMixin */]],
    components: { bBtn: __WEBPACK_IMPORTED_MODULE_1__button_button__["a" /* default */], bBtnClose: __WEBPACK_IMPORTED_MODULE_2__button_button_close__["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        var header = h(false);
        if (!t.hideHeader) {
            var modalHeader = $slots['modal-header'];
            if (!modalHeader) {
                var closeButton = h(false);
                if (!t.hideHeaderClose) {
                    closeButton = h('b-btn-close', {
                        props: {
                            disabled: t.is_transitioning,
                            ariaLabel: t.headerCloseLabel,
                            textVariant: t.headerTextVariant
                        },
                        on: { click: function click(evt) {
                                t.hide('header-close');
                            } }
                    }, [$slots['modal-header-close']]);
                }
                modalHeader = [h(t.titleTag, { class: ['modal-title'] }, [$slots['modal-title'] || t.title]), closeButton];
            }
            header = h('header', {
                ref: 'header',
                class: t.headerClasses,
                attrs: { id: t.safeId('__BV_modal_header_') }
            }, [modalHeader]);
        }

        var body = h('div', {
            ref: 'body',
            class: t.bodyClasses,
            attrs: { id: t.safeId('__BV_modal_body_') }
        }, [$slots.default]);

        var footer = h(false);
        if (!t.hideFooter) {
            var modalFooter = $slots['modal-footer'];
            if (!modalFooter) {
                var okButton = h(false);
                if (!t.okOnly) {
                    okButton = h('b-btn', {
                        props: {
                            variant: t.cancelVariant,
                            size: t.buttonSize,
                            disabled: t.cancelDisabled || t.busy || t.is_transitioning
                        },
                        on: { click: function click(evt) {
                                t.hide('cancel');
                            } }

                    }, [$slots['modal-cancel'] || t.cancelTitle]);
                }
                var cancelButton = h('b-btn', {
                    props: {
                        variant: t.okVariant,
                        size: t.buttonSize,
                        disabled: t.okDisabled || t.busy || t.is_transitioning
                    },
                    on: { click: function click(evt) {
                            t.hide('ok');
                        } }
                }, [$slots['modal-ok'] || t.okTitle]);
                modalFooter = [cancelButton, okButton];
            }
            footer = h('footer', {
                ref: 'footer',
                class: t.footerClasses,
                attrs: { id: t.safeId('__BV_modal_footer_') }
            }, [modalFooter]);
        }

        var modalContent = h('div', {
            ref: 'content',
            class: ['modal-content'],
            attrs: {
                tabindex: '-1',
                role: 'document',
                'aria-labelledby': t.hideHeader ? null : t.safeId('__BV_modal_header_'),
                'aria-describedby': t.safeId('__BV_modal_body_')
            },
            on: {
                focusout: t.onFocusout,
                click: function click(evt) {
                    evt.stopPropagation();
                }
            }
        }, [header, body, footer]);

        var modalDialog = h('div', { class: t.dialogClasses }, [modalContent]);

        var modal = h('div', {
            ref: 'modal',
            class: t.modalClasses,
            directives: [{ name: 'show', rawName: 'v-show', value: t.is_visible, expression: 'is_visible' }],
            attrs: {
                id: t.safeId(),
                role: 'dialog',
                'aria-hidden': t.is_visible ? null : 'true'
            },
            on: {
                click: t.onClickOut,
                keydown: t.onEsc
            }
        }, [modalDialog]);

        modal = h('transition', {
            props: {
                enterClass: '',
                enterToClass: '',
                enterActiveClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: ''
            },
            on: {
                'before-enter': t.onBeforeEnter,
                'enter': t.onEnter,
                'after-enter': t.onAfterEnter,
                'before-leave': t.onBeforeLeave,
                'leave': t.onLeave,
                'after-leave': t.onAfterLeave
            }
        }, [modal]);

        var backdrop = h(false);
        if (!t.hideBackdrop && (t.is_visible || t.is_transitioning)) {
            backdrop = h('div', { class: t.backdropClasses, attrs: { id: t.safeId('__BV_modal_backdrop_') } });
        }

        var outer = h(false);
        if (!t.is_hidden) {
            outer = h('div', { attrs: { id: t.safeId('__BV_modal_outer_') } }, [modal, backdrop]);
        }

        return h('div', {}, [outer]);
    },
    data: function data() {
        return {
            is_hidden: this.lazy || false,
            is_visible: false,
            is_transitioning: false,
            is_show: false,
            is_block: false,
            scrollbarWidth: 0,
            isBodyOverflowing: false,
            return_focus: this.returnFocus || null
        };
    },

    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        titleTag: {
            type: String,
            default: 'h5'
        },
        size: {
            type: String,
            default: 'md'
        },
        centered: {
            type: Boolean,
            default: false
        },
        buttonSize: {
            type: String,
            default: ''
        },
        noFade: {
            type: Boolean,
            default: false
        },
        noCloseOnBackdrop: {
            type: Boolean,
            default: false
        },
        noCloseOnEsc: {
            type: Boolean,
            default: false
        },
        noEnforceFocus: {
            type: Boolean,
            default: false
        },
        headerBgVariant: {
            type: String,
            default: null
        },
        headerBorderVariant: {
            type: String,
            default: null
        },
        headerTextVariant: {
            type: String,
            default: null
        },
        bodyBgVariant: {
            type: String,
            default: null
        },
        bodyTextVariant: {
            type: String,
            default: null
        },
        footerBgVariant: {
            type: String,
            default: null
        },
        footerBorderVariant: {
            type: String,
            default: null
        },
        footerTextVariant: {
            type: String,
            default: null
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        hideHeaderClose: {
            type: Boolean,
            default: false
        },
        hideBackdrop: {
            type: Boolean,
            default: false
        },
        okOnly: {
            type: Boolean,
            default: false
        },
        okDisabled: {
            type: Boolean,
            default: false
        },
        cancelDisabled: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        },
        returnFocus: {
            default: null
        },
        headerCloseLabel: {
            type: String,
            default: 'Close'
        },
        cancelTitle: {
            type: String,
            default: 'Cancel'
        },
        okTitle: {
            type: String,
            default: 'OK'
        },
        cancelVariant: {
            type: String,
            default: 'secondary'
        },
        okVariant: {
            type: String,
            default: 'primary'
        },
        lazy: {
            type: Boolean,
            default: false
        },
        busy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalClasses: function modalClasses() {
            return ['modal', {
                fade: !this.noFade,
                show: this.is_show,
                'd-block': this.is_block
            }];
        },
        dialogClasses: function dialogClasses() {
            var _ref;

            return ['modal-dialog', (_ref = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-' + this.size, Boolean(this.size)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'modal-dialog-centered', this.centered), _ref)];
        },
        backdropClasses: function backdropClasses() {
            return ['modal-backdrop', {
                fade: !this.noFade,
                show: this.is_show || this.noFade
            }];
        },
        headerClasses: function headerClasses() {
            var _ref2;

            return ['modal-header', (_ref2 = {
                'rounded-top': Boolean(this.headerBgVariant)
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'bg-' + this.headerBgVariant, Boolean(this.headerBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'text-' + this.headerTextVariant, Boolean(this.headerTextVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref2, 'border-' + this.headerBorderVariant, Boolean(this.headerBorderVariant)), _ref2)];
        },
        bodyClasses: function bodyClasses() {
            var _ref3;

            return ['modal-body', (_ref3 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, 'bg-' + this.bodyBgVariant, Boolean(this.bodyBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref3, 'text-' + this.bodyTextVariant, Boolean(this.bodyTextVariant)), _ref3)];
        },
        footerClasses: function footerClasses() {
            var _ref4;

            return ['modal-footer', (_ref4 = {
                'rounded-bottom': Boolean(this.footerBgVariant)
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'bg-' + this.footerBgVariant, Boolean(this.footerBgVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'text-' + this.footerTextVariant, Boolean(this.footerTextVariant)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref4, 'border-' + this.footerBorderVariant, Boolean(this.footerBorderVariant)), _ref4)];
        }
    },
    watch: {
        visible: function visible(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            this[newVal ? 'show' : 'hide']();
        }
    },
    methods: {
        show: function show() {
            if (this.is_visible) {
                return;
            }
            var showEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('show', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                relatedTarget: null
            });
            this.emitEvent(showEvt);
            if (showEvt.defaultPrevented || this.is_visible) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["j" /* hasClass */])(document.body, 'modal-open')) {
                this.$root.$once('bv::modal::hidden', this.doShow);
            } else {
                this.doShow();
            }
        },
        hide: function hide(trigger) {
            if (!this.is_visible) {
                return;
            }
            var hideEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('hide', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,

                relatedTarget: null,
                isOK: trigger || null,
                trigger: trigger || null,
                cancel: function cancel() {
                    Object(__WEBPACK_IMPORTED_MODULE_4__utils__["n" /* warn */])('b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().');
                    this.preventDefault();
                }
            });
            if (trigger === 'ok') {
                this.$emit('ok', hideEvt);
            } else if (trigger === 'cancel') {
                this.$emit('cancel', hideEvt);
            }
            this.emitEvent(hideEvt);

            if (hideEvt.defaultPrevented || !this.is_visible) {
                return;
            }

            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            this.is_visible = false;
            this.$emit('change', false);
        },
        doShow: function doShow() {
            var _this = this;

            this.is_hidden = false;
            this.$nextTick(function () {
                _this.is_visible = true;
                _this.$emit('change', true);

                _this._observer = Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* observeDom */])(_this.$refs.content, _this.adjustDialog.bind(_this), OBSERVER_CONFIG);
            });
        },
        onBeforeEnter: function onBeforeEnter() {
            this.is_transitioning = true;
            this.checkScrollbar();
            this.setScrollbar();
            this.adjustDialog();
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["a" /* addClass */])(document.body, 'modal-open');
            this.setResizeEvent(true);
        },
        onEnter: function onEnter() {
            this.is_block = true;
            this.$refs.modal.scrollTop = 0;
        },
        onAfterEnter: function onAfterEnter() {
            var _this2 = this;

            this.is_show = true;
            this.is_transitioning = false;
            this.$nextTick(function () {
                _this2.focusFirst();
                var shownEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('shown', {
                    cancelable: false,
                    vueTarget: _this2,
                    target: _this2.$refs.modal,
                    relatedTarget: null
                });
                _this2.emitEvent(shownEvt);
            });
        },
        onBeforeLeave: function onBeforeLeave() {
            this.is_transitioning = true;
            this.setResizeEvent(false);
        },
        onLeave: function onLeave() {
            this.is_show = false;
        },
        onAfterLeave: function onAfterLeave() {
            var _this3 = this;

            this.is_block = false;
            this.resetAdjustments();
            this.resetScrollbar();
            this.is_transitioning = false;
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["s" /* removeClass */])(document.body, 'modal-open');
            this.$nextTick(function () {
                _this3.is_hidden = _this3.lazy || false;
                _this3.returnFocusTo();
                var hiddenEvt = new __WEBPACK_IMPORTED_MODULE_5__utils_bv_event_class__["a" /* default */]('hidden', {
                    cancelable: false,
                    vueTarget: _this3,
                    target: _this3.lazy ? null : _this3.$refs.modal,
                    relatedTarget: null
                });
                _this3.emitEvent(hiddenEvt);
            });
        },
        emitEvent: function emitEvent(bvEvt) {
            var type = bvEvt.type;
            this.$emit(type, bvEvt);
            this.$root.$emit('bv::modal::' + type, bvEvt);
        },
        onClickOut: function onClickOut(evt) {
            if (this.is_visible && !this.noCloseOnBackdrop) {
                this.hide('backdrop');
            }
        },
        onEsc: function onEsc(evt) {
            if (evt.keyCode === __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* KeyCodes */].ESC && this.is_visible && !this.noCloseOnEsc) {
                this.hide('esc');
            }
        },
        onFocusout: function onFocusout(evt) {
            var content = this.$refs.content;
            if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                content.focus();
            }
        },
        setResizeEvent: function setResizeEvent(on) {
            var _this4 = this;

            ['resize', 'orientationchange'].forEach(function (evtName) {
                if (on) {
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["d" /* eventOn */])(window, evtName, _this4.adjustDialog);
                } else {
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["c" /* eventOff */])(window, evtName, _this4.adjustDialog);
                }
            });
        },
        showHandler: function showHandler(id, triggerEl) {
            if (id === this.id) {
                this.return_focus = triggerEl || null;
                this.show();
            }
        },
        hideHandler: function hideHandler(id) {
            if (id === this.id) {
                this.hide();
            }
        },
        modalListener: function modalListener(bvEvt) {
            if (bvEvt.vueTarget !== this) {
                this.hide();
            }
        },
        focusFirst: function focusFirst() {
            if (typeof document === 'undefined') {
                return;
            }
            var content = this.$refs.content;
            var modal = this.$refs.modal;
            var activeElement = document.activeElement;
            if (activeElement && content && content.contains(activeElement)) {} else if (content) {
                if (modal) {
                    modal.scrollTop = 0;
                }

                content.focus();
            }
        },
        returnFocusTo: function returnFocusTo() {
            var el = this.returnFocus || this.return_focus || null;
            if (typeof el === 'string') {
                el = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["t" /* select */])(el);
            }
            if (el) {
                el = el.$el || el;
                if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["m" /* isVisible */])(el)) {
                    el.focus();
                }
            }
        },
        getScrollbarWidth: function getScrollbarWidth() {
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            document.body.appendChild(scrollDiv);
            this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        },
        adjustDialog: function adjustDialog() {
            if (!this.is_visible) {
                return;
            }
            var modal = this.$refs.modal;
            var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
            if (!this.isBodyOverflowing && isModalOverflowing) {
                modal.style.paddingLeft = this.scrollbarWidth + 'px';
            }
            if (this.isBodyOverflowing && !isModalOverflowing) {
                modal.style.paddingRight = this.scrollbarWidth + 'px';
            }
        },
        resetAdjustments: function resetAdjustments() {
            var modal = this.$refs.modal;
            if (modal) {
                modal.style.paddingLeft = '';
                modal.style.paddingRight = '';
            }
        },
        checkScrollbar: function checkScrollbar() {
            var rect = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["f" /* getBCR */])(document.body);
            this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        },
        setScrollbar: function setScrollbar() {
            if (this.isBodyOverflowing) {
                var computedStyle = window.getComputedStyle;
                var body = document.body;
                var scrollbarWidth = this.scrollbarWidth;

                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                    var actualPadding = el.style.paddingRight;
                    var calculatedPadding = computedStyle(el).paddingRight || 0;
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(el, 'data-padding-right', actualPadding);
                    el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
                });

                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.STICKY_CONTENT).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + 'px';
                });

                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.NAVBAR_TOGGLER).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + 'px';
                });

                var actualPadding = body.style.paddingRight;
                var calculatedPadding = computedStyle(body).paddingRight;
                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["v" /* setAttr */])(body, 'data-padding-right', actualPadding);
                body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
            }
        },
        resetScrollbar: function resetScrollbar() {
            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* hasAttr */])(el, 'data-padding-right')) {
                    el.style.paddingRight = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(el, 'data-padding-right') || '';
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* removeAttr */])(el, 'data-padding-right');
                }
            });

            Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["u" /* selectAll */])(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).forEach(function (el) {
                if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* hasAttr */])(el, 'data-margin-right')) {
                    el.style.marginRight = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(el, 'data-margin-right') || '';
                    Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* removeAttr */])(el, 'data-margin-right');
                }
            });

            var body = document.body;
            if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["i" /* hasAttr */])(body, 'data-padding-right')) {
                body.style.paddingRight = Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["e" /* getAttr */])(body, 'data-padding-right') || '';
                Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["r" /* removeAttr */])(body, 'data-padding-right');
            }
        }
    },
    created: function created() {
        this._observer = null;
    },
    mounted: function mounted() {
        this.getScrollbarWidth();

        this.listenOnRoot('bv::show::modal', this.showHandler);
        this.listenOnRoot('bv::hide::modal', this.hideHandler);

        this.listenOnRoot('bv::modal::show', this.modalListener);

        if (this.visible === true) {
            this.show();
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
        this.setResizeEvent(false);

        Object(__WEBPACK_IMPORTED_MODULE_6__utils_dom__["s" /* removeClass */])(document.body, 'modal-open');
        this.resetAdjustments();
        this.resetScrollbar();
    }
});

/***/ }),
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_vue__ = __webpack_require__(258);
function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(0);






var props = {
  perPage: {
    type: Number,
    default: 20
  },
  totalRows: {
    type: Number,
    default: 20
  },
  ariaControls: {
    type: String,
    default: null
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins__["k" /* paginationMixin */]],
  props: props,
  computed: {
    numberOfPages: function numberOfPages() {
      var result = Math.ceil(this.totalRows / this.perPage);
      return result < 1 ? 1 : result;
    }
  },
  methods: {
    onClick: function onClick(num, evt) {
      var _this = this;

      if (num > this.numberOfPages) {
        num = this.numberOfPages;
      } else if (num < 1) {
        num = 1;
      }
      this.currentPage = num;
      this.$nextTick(function () {
        var target = evt.target;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["m" /* isVisible */])(target) && _this.$el.contains(target) && target.focus) {
          target.focus();
        } else {
          _this.focusCurrent();
        }
      });
      this.$emit('change', this.currentPage);
    },
    makePage: function makePage(pagenum) {
      return pagenum;
    },
    linkProps: function linkProps(pagenum) {
      return { href: '#' };
    }
  }
});

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_nav_vue__ = __webpack_require__(263);
function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_pagination_nav_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__link_link__ = __webpack_require__(10);








var routerProps = Object(__WEBPACK_IMPORTED_MODULE_4__link_link__["b" /* pickLinkProps */])('activeClass', 'exactActiveClass', 'append', 'exact', 'replace', 'target', 'rel');

var props = Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["a" /* assign */])({
  numberOfPages: {
    type: Number,
    default: 1
  },
  baseUrl: {
    type: String,
    default: '/'
  },
  useRouter: {
    type: Boolean,
    default: false
  },
  linkGen: {
    type: Function,
    default: null
  },
  pageGen: {
    type: Function,
    default: null
  }
}, routerProps);

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["k" /* paginationMixin */]],
  props: props,
  computed: {
    isNav: function isNav() {
      return true;
    }
  },
  methods: {
    onClick: function onClick(pageNum, evt) {
      this.currentPage = pageNum;
    },
    makePage: function makePage(pagenum) {
      if (this.pageGen && typeof this.pageGen === 'function') {
        return this.pageGen(pagenum);
      }
      return pagenum;
    },
    makeLink: function makeLink(pagenum) {
      if (this.linkGen && typeof this.linkGen === 'function') {
        return this.linkGen(pagenum);
      }
      var link = '' + this.baseUrl + pagenum;
      return this.useRouter ? { path: link } : link;
    },
    linkProps: function linkProps(pagenum) {
      var link = this.makeLink(pagenum);
      var props = {
        href: typeof link === 'string' ? link : void 0,
        target: this.target || null,
        rel: this.rel || null,
        disabled: this.disabled
      };
      if (this.useRouter || (typeof link === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(link)) === 'object') {
        props = Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["a" /* assign */])(props, {
          to: link,
          exact: this.exact,
          activeClass: this.activeClass,
          exactActiveClass: this.exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      }
      return props;
    }
  }
});

/***/ }),
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(282);
function injectStyle (ssrContext) {
  __webpack_require__(281)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_bar__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { bProgressBar: __WEBPACK_IMPORTED_MODULE_0__progress_bar__["a" /* default */] },
    render: function render(h) {
        var t = this;
        var childNodes = t.$slots.default;
        if (!childNodes) {
            childNodes = h('b-progress-bar', {
                props: {
                    value: t.value,
                    max: t.max,
                    precision: t.precision,
                    variant: t.variant,
                    animated: t.animated,
                    striped: t.striped,
                    showProgress: t.showProgress,
                    showValue: t.showValue
                }
            });
        }
        return h('div', { class: ['progress'], style: t.progressHeight }, [childNodes]);
    },

    props: {
        variant: {
            type: String,
            default: null
        },
        striped: {
            type: Boolean,
            default: false
        },
        animated: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: null
        },
        precision: {
            type: Number,
            default: 0
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        showValue: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: 100
        },

        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        progressHeight: function progressHeight() {
            return { height: this.height || null };
        }
    }
});

/***/ }),
/* 283 */,
/* 284 */,
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(287);
function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startcase__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_startcase__);









function toString(v) {
  if (!v) {
    return '';
  }
  if (v instanceof Object) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(v).map(function (k) {
      return toString(v[k]);
    }).join(' ');
  }
  return String(v);
}

function recToString(obj) {
  if (!(obj instanceof Object)) {
    return '';
  }
  return toString(Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(obj).reduce(function (o, k) {
    if (!/^_/.test(k)) {
      o[k] = obj[k];
    }
    return o;
  }, {}));
}

function defaultSortCompare(a, b, sortBy) {
  if (typeof a[sortBy] === 'number' && typeof b[sortBy] === 'number') {
    return a[sortBy] < b[sortBy] && -1 || a[sortBy] > b[sortBy] && 1 || 0;
  }
  return toString(a[sortBy]).localeCompare(toString(b[sortBy]), undefined, {
    numeric: true
  });
}

function processField(key, value) {
  var field = null;
  if (typeof value === 'string') {
    field = { key: key, label: value };
  } else if (typeof value === 'function') {
    field = { key: key, formatter: value };
  } else if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
    field = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])({}, value);
    field.key = field.key || key;
  } else if (value !== false) {
    field = { key: key };
  }
  return field;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["j" /* listenOnRootMixin */]],
  render: function render(h) {
    var t = this;
    var $slots = t.$slots;
    var $scoped = t.$scopedSlots;
    var fields = t.computedFields;
    var items = t.computedItems;

    var caption = h(false);
    if (t.caption || $slots['table-caption']) {
      var data = { style: t.captionStyles };
      if (!$slots['table-caption']) {
        data.domProps = { innerHTML: t.caption };
      }
      caption = h('caption', data, $slots['table-caption']);
    }

    var colgroup = $slots['table-colgroup'] ? h('colgroup', {}, $slots['table-colgroup']) : h(false);

    var ths = fields.map(function (field) {
      var data = {
        key: field.key,
        class: t.fieldClasses(field),
        style: field.thStyle || {},
        attrs: {
          'tabindex': field.sortable ? '0' : null,
          'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
          'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
        },
        on: {
          click: function click(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            t.headClicked(evt, field);
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* KeyCodes */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* KeyCodes */].SPACE) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            }
          }
        }
      };
      var slot = $scoped['HEAD_' + field.key];
      if (slot) {
        slot = slot({ label: field.label, column: field.key, field: field });
      } else {
        data.domProps = { innerHTML: field.label };
      }
      return h('th', data, slot);
    });
    var thead = h('thead', { class: t.headClasses }, [h('tr', {}, ths)]);

    var tfoot = h(false);
    if (t.footClone) {
      var _ths = fields.map(function (field) {
        var data = {
          key: field.key,
          class: t.fieldClasses(field),
          style: field.thStyle || {},
          attrs: {
            'tabindex': field.sortable ? '0' : null,
            'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
            'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
          },
          on: {
            click: function click(evt) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            },
            keydown: function keydown(evt) {
              var keyCode = evt.keyCode;
              if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* KeyCodes */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils__["a" /* KeyCodes */].SPACE) {
                evt.stopPropagation();
                evt.preventDefault();
                t.headClicked(evt, field);
              }
            }
          }
        };
        var slot = $scoped['FOOT_' + field.key] ? $scoped['FOOT_' + field.key] : $scoped['HEAD_' + field.key];
        if (slot) {
          slot = [slot({ label: field.label, column: field.key, field: field })];
        } else {
          data.domProps = { innerHTML: field.label };
        }
        return h('th', data, slot);
      });
      tfoot = h('tfoot', { class: t.footClasses }, [h('tr', {}, _ths)]);
    }

    var rows = [];

    if ($scoped['top-row']) {
      rows.push(h('tr', {}, [$scoped['top-row']({ coloumns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    items.forEach(function (item, index) {
      var detailsSlot = $scoped['row-details'];

      var tds = fields.map(function (field) {
        var data = {
          key: field.key,
          class: t.tdClasses(field, item),
          attrs: field.tdAttr || {}
        };
        var childNodes = void 0;
        if ($scoped[field.key]) {
          childNodes = [$scoped[field.key]({
            item: item,
            index: index,
            unformatted: item[field.key],
            value: t.getFormattedValue(item, field)
          })];
        } else {
          data.domProps = { innerHTML: t.getFormattedValue(item, field) };
        }
        return h('td', data, childNodes);
      });

      rows.push(h('tr', {
        key: index,
        class: [t.rowClasses(item), item._showDetails && detailsSlot ? 'b-table-has-details' : ''],
        on: {
          click: function click(evt) {
            t.rowClicked(evt, item, index);
          },
          dblclick: function dblclick(evt) {
            t.rowDblClicked(evt, item, index);
          },
          mouseenter: function mouseenter(evt) {
            t.rowHovered(evt, item, index);
          }
        }
      }, tds));

      if (item._showDetails && detailsSlot) {
        var details = h('td', { attrs: { colspan: String(fields.length) } }, [detailsSlot({ item: item, index: index, fields: fields })]);
        rows.push(h('tr', { key: index + '-details', class: ['b-table-details'] }, [details]));
      } else {
        rows.push(h(false));
      }
    });

    if (t.showEmpty && (!items || items.length === 0)) {
      var inner = t.filter ? $slots['emptyfiltered'] : $slots['empty'];
      if (!inner) {
        inner = h('div', {
          class: ['text-center', 'my-2'],
          domProps: { innerHTML: t.filter ? t.emptyFilteredText : t.emptyText }
        });
      }
      var content = h('div', { attrs: { role: 'alert', 'aria-live': 'polite' } }, [inner]);
      rows.push(h('tr', [h('td', { attrs: { colspan: String(fields.length) } }, [content])]));
    } else {
      rows.push(h(false));
    }

    if ($scoped['bottom-row']) {
      rows.push(h('tr', {}, [$scoped['bottom-row']({ columns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    var tbody = h('tbody', {}, rows);

    return h('table', {
      class: t.tableClasses,
      attrs: { id: t.id || null, 'aria-busy': t.computedBusy ? 'true' : 'false' }
    }, [caption, colgroup, thead, tfoot, tbody]);
  },
  data: function data() {
    return {
      localSortBy: this.sortBy || '',
      localSortDesc: this.sortDesc || false,
      localItems: [],

      filteredItems: [],
      localBusy: this.busy
    };
  },

  props: {
    id: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: null
    },
    captionTop: {
      type: Boolean,
      default: false
    },
    items: {
      type: [Array, Function],
      default: function _default() {
        return [];
      }
    },
    sortBy: {
      type: String,
      default: null
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    apiUrl: {
      type: String,
      default: ''
    },
    fields: {
      type: [Object, Array],
      default: null
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: function _default() {
        if (this && typeof this.inverse === 'boolean') {
          Object(__WEBPACK_IMPORTED_MODULE_1__utils__["n" /* warn */])("b-table: prop 'inverse' has been deprecated. Use 'dark' instead");
          return this.dark;
        }
        return false;
      }
    },
    inverse: {
      type: Boolean,
      default: null
    },
    hover: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: [Boolean, String],
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    headVariant: {
      type: String,
      default: ''
    },
    footVariant: {
      type: String,
      default: ''
    },
    perPage: {
      type: Number,
      default: null
    },
    currentPage: {
      type: Number,
      default: 1
    },
    filter: {
      type: [String, RegExp, Function],
      default: null
    },
    sortCompare: {
      type: Function,
      default: null
    },
    noLocalSorting: {
      type: Boolean,
      default: false
    },
    noProviderPaging: {
      type: Boolean,
      default: false
    },
    noProviderSorting: {
      type: Boolean,
      default: false
    },
    noProviderFiltering: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    footClone: {
      type: Boolean,
      default: false
    },
    labelSortAsc: {
      type: String,
      default: 'Click to sort Ascending'
    },
    labelSortDesc: {
      type: String,
      default: 'Click to sort Descending'
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'There are no records to show'
    },
    emptyFilteredText: {
      type: String,
      default: 'There are no records matching your request'
    }
  },
  watch: {
    items: function items(newVal, oldVal) {
      if (oldVal !== newVal) {
        this._providerUpdate();
      }
    },
    context: function context(newVal, oldVal) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* looseEqual */])(newVal, oldVal)) {
        this.$emit('context-changed', newVal);
      }
    },
    filteredItems: function filteredItems(newVal, oldVal) {
      if (this.localFiltering && newVal.length !== oldVal.length) {
        this.$emit('filtered', newVal);
      }
    },
    sortDesc: function sortDesc(newVal, oldVal) {
      if (newVal === this.localSortDesc) {
        return;
      }
      this.localSortDesc = newVal || false;
    },
    localSortDesc: function localSortDesc(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:sortDesc', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    sortBy: function sortBy(newVal, oldVal) {
      if (newVal === this.localSortBy) {
        return;
      }
      this.localSortBy = newVal || null;
    },
    localSortBy: function localSortBy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:sortBy', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    perPage: function perPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    currentPage: function currentPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    filter: function filter(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderFiltering) {
        this._providerUpdate();
      }
    },
    localBusy: function localBusy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:busy', newVal);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.localSortBy = this.sortBy;
    this.localSortDesc = this.sortDesc;
    this.localBusy = this.busy;
    if (this.hasProvider) {
      this._providerUpdate();
    }
    this.listenOnRoot('bv::refresh::table', function (id) {
      if (id === _this.id || id === _this) {
        _this._providerUpdate();
      }
    });
  },

  computed: {
    tableClasses: function tableClasses() {
      var responsive = this.responsive === '' ? true : this.responsive;
      return ['table', 'b-table', this.striped ? 'table-striped' : '', this.hover ? 'table-hover' : '', this.dark ? 'table-dark' : '', this.bordered ? 'table-bordered' : '', this.outlined ? 'border' : '', responsive === true ? 'table-responsive' : Boolean(responsive) ? 'table-responsive-' + responsive : '', this.fixed ? 'table-fixed' : '', this.small ? 'table-sm' : ''];
    },
    headClasses: function headClasses() {
      return this.headVariant ? 'thead-' + this.headVariant : '';
    },
    footClasses: function footClasses() {
      var variant = this.footVariant || this.headVariant || null;
      return variant ? 'thead-' + variant : '';
    },
    captionStyles: function captionStyles() {
      return this.captionTop ? { captionSide: 'top' } : {};
    },
    hasProvider: function hasProvider() {
      return this.items instanceof Function;
    },
    localFiltering: function localFiltering() {
      return this.hasProvider ? this.noProviderFiltering : true;
    },
    localSorting: function localSorting() {
      return this.hasProvider ? this.noProviderSorting : !this.noLocalSorting;
    },
    localPaging: function localPaging() {
      return this.hasProvider ? this.noProviderPaging : true;
    },
    context: function context() {
      return {
        perPage: this.perPage,
        currentPage: this.currentPage,
        filter: this.filter,
        apiUrl: this.apiUrl,
        sortBy: this.localSortBy,
        sortDesc: this.localSortDesc
      };
    },
    computedFields: function computedFields() {
      var _this2 = this;

      var fields = [];
      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["d" /* isArray */])(this.fields)) {
        this.fields.filter(function (f) {
          return f;
        }).forEach(function (f) {
          if (typeof f === 'string') {
            fields.push({ key: f, label: __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(f) });
          } else if ((typeof f === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f)) === 'object' && f.key && typeof f.key === 'string') {
            fields.push(Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])({}, f));
          } else if ((typeof f === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f)) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(f).length === 1) {
            var key = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(f)[0];
            var field = processField(key, f[key]);
            if (field) {
              fields.push(field);
            }
          }
        });
      } else if (this.fields && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.fields) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(this.fields).length > 0) {
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(this.fields).forEach(function (key) {
          var field = processField(key, _this2.fields[key]);
          if (field) {
            fields.push(field);
          }
        });
      }

      if (fields.length === 0 && this.computedItems.length > 0) {
        var sample = this.computedItems[0];
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(sample).forEach(function (k) {
          fields.push({ key: k, label: __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(k) });
        });
      }

      var memo = {};
      return fields.filter(function (f) {
        if (!memo[f.key]) {
          memo[f.key] = true;
          f.label = f.label || __WEBPACK_IMPORTED_MODULE_5_lodash_startcase___default()(f.key);
          return true;
        }
        return false;
      });
    },
    computedItems: function computedItems() {
      var perPage = this.perPage;
      var currentPage = this.currentPage;
      var filter = this.filter;
      var sortBy = this.localSortBy;
      var sortDesc = this.localSortDesc;
      var sortCompare = this.sortCompare;
      var localFiltering = this.localFiltering;
      var localSorting = this.localSorting;
      var localPaging = this.localPaging;
      var items = this.hasProvider ? this.localItems : this.items;
      if (!items) {
        this.$nextTick(this._providerUpdate);
        return [];
      }

      items = items.slice();

      if (filter && localFiltering) {
        if (filter instanceof Function) {
          items = items.filter(filter);
        } else {
          var regex = void 0;
          if (filter instanceof RegExp) {
            regex = filter;
          } else {
            regex = new RegExp('.*' + filter + '.*', 'ig');
          }
          items = items.filter(function (item) {
            var test = regex.test(recToString(item));
            regex.lastIndex = 0;
            return test;
          });
        }
      }
      if (localFiltering) {
        this.filteredItems = items.slice();
      }

      if (sortBy && localSorting) {
        items = items.sort(function sortItemsFn(a, b) {
          var ret = null;
          if (typeof sortCompare === 'function') {
            ret = sortCompare(a, b, sortBy);
          }
          if (ret === null || ret === undefined) {
            ret = defaultSortCompare(a, b, sortBy);
          }

          return (ret || 0) * (sortDesc ? -1 : 1);
        });
      }

      if (Boolean(perPage) && localPaging) {
        items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
      }

      this.$emit('input', items);
      return items;
    },
    computedBusy: function computedBusy() {
      return this.busy || this.localBusy;
    }
  },
  methods: {
    keys: __WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */],
    fieldClasses: function fieldClasses(field) {
      return [field.sortable ? 'sorting' : '', field.sortable && this.localSortBy === field.key ? 'sorting_' + (this.localSortDesc ? 'desc' : 'asc') : '', field.variant ? 'table-' + field.variant : '', field.class ? field.class : '', field.thClass ? field.thClass : ''];
    },
    tdClasses: function tdClasses(field, item) {
      var cellVariant = '';
      if (item._cellVariants && item._cellVariants[field.key]) {
        cellVariant = (this.dark ? 'bg' : 'table') + '-' + item._cellVariants[field.key];
      }
      return [field.variant && !cellVariant ? (this.dark ? 'bg' : 'table') + '-' + field.variant : '', cellVariant, field.class ? field.class : '', field.tdClass ? field.tdClass : ''];
    },
    rowClasses: function rowClasses(item) {
      return [item._rowVariant ? (this.dark ? 'bg' : 'table') + '-' + item._rowVariant : ''];
    },
    rowClicked: function rowClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        return;
      }
      this.$emit('row-clicked', item, index, e);
    },
    rowDblClicked: function rowDblClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        return;
      }
      this.$emit('row-dblclicked', item, index, e);
    },
    rowHovered: function rowHovered(e, item, index) {
      if (this.stopIfBusy(e)) {
        return;
      }
      this.$emit('row-hovered', item, index, e);
    },
    headClicked: function headClicked(e, field) {
      if (this.stopIfBusy(e)) {
        return;
      }
      var sortChanged = false;
      if (field.sortable) {
        if (field.key === this.localSortBy) {
          this.localSortDesc = !this.localSortDesc;
        } else {
          this.localSortBy = field.key;
          this.localSortDesc = false;
        }
        sortChanged = true;
      } else if (this.localSortBy) {
        this.localSortBy = null;
        this.localSortDesc = false;
        sortChanged = true;
      }
      this.$emit('head-clicked', field.key, field, e);
      if (sortChanged) {
        this.$emit('sort-changed', this.context);
      }
    },
    stopIfBusy: function stopIfBusy(evt) {
      if (this.computedBusy) {
        evt.preventDefault();
        evt.stopPropagation();
        return true;
      }
      return false;
    },
    refresh: function refresh() {
      if (this.hasProvider) {
        this._providerUpdate();
      }
    },
    _providerSetLocal: function _providerSetLocal(items) {
      this.localItems = items && items.length > 0 ? items.slice() : [];
      this.localBusy = false;
      this.$emit('refreshed');
      this.emitOnRoot('table::refreshed', this.id);
    },
    _providerUpdate: function _providerUpdate() {
      var _this3 = this;

      if (this.computedBusy || !this.hasProvider) {
        return;
      }

      this.localBusy = true;

      var data = this.items(this.context, this._providerSetLocal);
      if (data) if (data.then && typeof data.then === 'function') {
        data.then(function (items) {
          _this3._providerSetLocal(items);
        });
      } else {
        this._providerSetLocal(data);
      }
    },
    getFormattedValue: function getFormattedValue(item, field) {
      var key = field.key;
      var formatter = field.formatter;
      var parent = this.$parent;
      var value = item[key];
      if (formatter) {
        if (typeof formatter === 'function') {
          value = formatter(value, key, item);
        } else if (typeof formatter === 'string' && typeof parent[formatter] === 'function') {
          value = parent[formatter](value, key, item);
        }
      }
      return value;
    }
  }
});

/***/ }),
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_577f69ff_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(339);
function injectStyle (ssrContext) {
  __webpack_require__(332)
  __webpack_require__(333)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_577f69ff_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_Loading_vue__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_toastr__);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    components: {
        'cabinet-loading': __WEBPACK_IMPORTED_MODULE_0__containers_Loading_vue__["a" /* default */],
        'cabinet-notification': __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default.a
    },
    data: function data() {
        return {
            ready: false
        };
    },

    computed: {
        isCabinetReady: function isCabinetReady() {
            return this.$auth.ready() && this.ready;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.refresh();

        setTimeout(function () {
            _this.ready = true;
        }, 100);
    },

    methods: {
        refreshRate: function refreshRate() {
            if (this.$auth.check()) {
                this.$store.dispatch('refreshRate');
            }
        },
        refreshUserdata: function refreshUserdata() {
            if (this.$auth.check()) {
                this.$store.dispatch('refreshUserdata');
            }
        },
        refresh: function refresh() {
            var _this2 = this;

            this.refreshRate();
            this.refreshUserdata();

            var updateTime = 100;

            if (this.$auth.check()) {
                updateTime *= 200;
            }

            setTimeout(function () {
                _this2.refresh();
            }, updateTime);
        }
    }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e01d26de_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(338);
function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e01d26de_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'loading'
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{attrs:{"id":"loader"}}),_vm._v(" "),_c('div',{staticClass:"loader-section section-left"}),_vm._v(" "),_c('div',{staticClass:"loader-section section-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCabinetReady)?_c('div',[_c('cabinet-notification'),_vm._v(" "),_c('router-view')],1):_c('cabinet-loading')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_Full_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Auth_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Confirmation_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Error_PageNotFound_vue__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Frontend_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Dashboard_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Profile_vue__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Finance_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Finance_Accounts_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Finance_History_vue__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Deposits_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Credits_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Franchising_vue__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Franchising_Franchisee_vue__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Admin_Orders_vue__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Login_vue__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Auth_AutoLogin_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Logout_vue__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Registration_vue__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_RemindPassword_vue__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Confirmation_Registration_vue__ = __webpack_require__(462);
































/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue_router__["a" /* default */]({
    hashbang: false,

    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    },
    routes: [{
        path: '',
        name: 'Frontend',
        component: __WEBPACK_IMPORTED_MODULE_5__views_Frontend_vue__["a" /* default */],
        meta: {
            label: 'Главная',
            auth: null
        }
    }, {
        path: '/auth',
        redirect: {
            name: 'AuthLogin'
        },
        component: __WEBPACK_IMPORTED_MODULE_2__containers_Auth_vue__["a" /* default */],
        children: [{
            path: 'login',
            name: 'AuthLogin',
            component: __WEBPACK_IMPORTED_MODULE_16__views_Login_vue__["a" /* default */],
            meta: {
                label: 'Вход',
                auth: false
            }
        }, {
            path: 'autologin/:token',
            name: 'AuthAutoLogin',
            component: __WEBPACK_IMPORTED_MODULE_17__views_Auth_AutoLogin_vue__["a" /* default */],
            meta: {
                auth: false
            }
        }, {
            path: 'logout',
            name: 'AuthLogout',
            component: __WEBPACK_IMPORTED_MODULE_18__views_Logout_vue__["a" /* default */],
            meta: {
                label: 'Выход',
                auth: true,
                confirm: true
            }
        }, {
            path: 'registration',
            name: 'AuthRegistration',
            component: __WEBPACK_IMPORTED_MODULE_19__views_Registration_vue__["a" /* default */],
            meta: {
                label: 'Регистрация',
                auth: false
            }
        }, {
            path: 'remind',
            name: 'AuthRemindPassword',
            component: __WEBPACK_IMPORTED_MODULE_20__views_RemindPassword_vue__["a" /* default */],
            meta: {
                label: 'Восстановление пароля',
                auth: false
            }
        }]
    }, {
        path: '/cabinet',
        redirect: {
            name: 'Dashboard'
        },
        name: 'Cabinet',
        meta: {
            label: 'Кабинет'
        },
        component: __WEBPACK_IMPORTED_MODULE_1__containers_Full_vue__["a" /* default */],
        children: [{
            path: 'dashboard',
            name: 'Dashboard',
            component: __WEBPACK_IMPORTED_MODULE_6__views_Dashboard_vue__["a" /* default */],
            meta: {
                label: 'Сводка',
                auth: true
            }
        }, {
            path: 'profile',
            name: 'Profile',
            component: __WEBPACK_IMPORTED_MODULE_7__views_Profile_vue__["a" /* default */],
            meta: {
                label: 'Профиль',
                auth: true
            }
        }, {
            path: 'franchising',
            name: 'Franchising',
            component: __WEBPACK_IMPORTED_MODULE_13__views_Franchising_vue__["a" /* default */],
            meta: {
                label: 'Сотрудникам',
                auth: true
            },
            children: [{
                path: 'marketing',
                name: 'FranchisingMarketing',
                component: __WEBPACK_IMPORTED_MODULE_4__views_Error_PageNotFound_vue__["a" /* default */],
                meta: {
                    label: 'Маркетинг',
                    auth: true
                }
            }, {
                path: 'franchisee',
                name: 'FranchisingFranchisee',
                component: __WEBPACK_IMPORTED_MODULE_14__views_Franchising_Franchisee_vue__["a" /* default */],
                meta: {
                    label: 'Франшизы',
                    auth: true
                }
            }]
        }, {
            path: 'finance',
            name: 'Finance',
            component: __WEBPACK_IMPORTED_MODULE_8__views_Finance_vue__["a" /* default */],
            meta: {
                label: 'Финансы',
                auth: true
            },
            children: [{
                path: 'history',
                name: 'FinanceHistory',
                component: __WEBPACK_IMPORTED_MODULE_10__views_Finance_History_vue__["a" /* default */],
                meta: {
                    label: 'История',
                    auth: true
                }
            }, {
                path: 'accounts',
                name: 'FinanceAccounts',
                component: __WEBPACK_IMPORTED_MODULE_9__views_Finance_Accounts_vue__["a" /* default */],
                meta: {
                    label: 'Счета',
                    auth: true
                }
            }]
        }, {
            path: 'deposits',
            name: 'Deposits',
            component: __WEBPACK_IMPORTED_MODULE_11__views_Deposits_vue__["a" /* default */],
            meta: {
                label: 'Депозиты',
                auth: true
            }
        }, {
            path: 'credits',
            name: 'Credits',
            component: __WEBPACK_IMPORTED_MODULE_12__views_Credits_vue__["a" /* default */],
            meta: {
                label: 'Кредиты',
                auth: true
            }
        }]
    }, {
        path: '/admin',
        name: 'Admin',
        component: __WEBPACK_IMPORTED_MODULE_1__containers_Full_vue__["a" /* default */],
        meta: {
            label: 'Админка',
            auth: ['admin']
        },
        children: [{
            path: 'dashboard',
            name: 'AdminDashboard',
            component: __WEBPACK_IMPORTED_MODULE_4__views_Error_PageNotFound_vue__["a" /* default */],
            meta: {
                label: 'Админка',
                auth: ['admin']
            }
        }, {
            path: 'orders',
            name: 'AdminOrders',
            component: __WEBPACK_IMPORTED_MODULE_15__views_Admin_Orders_vue__["a" /* default */],
            meta: {
                label: 'Заказы',
                auth: ['admin']
            }
        }]
    }, {
        path: '/confirm',
        name: 'Confirmation',
        component: __WEBPACK_IMPORTED_MODULE_3__containers_Confirmation_vue__["a" /* default */],
        children: [{
            path: 'registration/:token',
            name: 'ConfirmRegistration',
            component: __WEBPACK_IMPORTED_MODULE_21__views_Confirmation_Registration_vue__["a" /* default */]
        }]
    }, {
        path: '/partner/:referrer',
        beforeEnter: function beforeEnter(to, from, next) {
            var referrer = encodeURIComponent(to.params['referrer']);

            var expires = new Date();
            expires.setTime(expires.getTime() + 12096e5);

            var updatedCookie = 'profi-bank_referrer' + '=' + referrer;

            updatedCookie += '; expires=' + expires.toUTCString();
            document.cookie = updatedCookie;

            next({ name: 'AuthRegistration' });
        }
    }, {
        path: '*',
        component: __WEBPACK_IMPORTED_MODULE_4__views_Error_PageNotFound_vue__["a" /* default */]
    }]
}));

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_089ce00a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(385);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_089ce00a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components___ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_toastr__);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'full',
    components: {
        AppHeader: __WEBPACK_IMPORTED_MODULE_0__components___["c" /* Header */],
        AppSidebar: __WEBPACK_IMPORTED_MODULE_0__components___["d" /* Sidebar */],
        AppAside: __WEBPACK_IMPORTED_MODULE_0__components___["a" /* Aside */],
        AppFooter: __WEBPACK_IMPORTED_MODULE_0__components___["b" /* Footer */],

        'vue-toastr': __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default.a
    },
    data: function data() {
        return {};
    },

    computed: {
        name: function name() {
            return this.$route.name;
        }
    },
    created: function created() {
        var _this = this;

        this.$on('alert-info', function (message) {
            _this.$refs['toastr'].i(message);
        });
    }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(382);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* unused harmony reexport Breadcrumb */
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dafc7d1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(350);
function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dafc7d1_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Callout_vue__ = __webpack_require__(113);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'aside',
    components: {
        Callout: __WEBPACK_IMPORTED_MODULE_0__Callout_vue__["a" /* default */]
    }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        variant: {
            type: String
        }
    },
    computed: {
        classList: function classList() {
            return ['callout', this.calloutVariant];
        },
        calloutVariant: function calloutVariant() {
            return this.variant ? 'callout-' + this.variant : '';
        }
    }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('Callout',{staticClass:"m-0 py-2 text-center bg-light text-uppercase"},[_c('b-media',[_c('a',{staticClass:"logo",attrs:{"href":"http://profi-planet.org","target":"_blank"}},[_c('b-img',{attrs:{"left":"","width":"35","height":"35","src":"../assets/img/profi_planet_logo.png","alt":"Profi-Planet.org"}}),_vm._v(" "),_c('b',[_vm._v("Profi-Planet")])],1)])],1),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-2 text-center bg-light text-uppercase",attrs:{"variant":"warning"}},[_c('b-media',[_c('a',{staticClass:"logo",attrs:{"href":"http://profi-planet.org","target":"_blank"}},[_c('b-img',{attrs:{"left":"","width":"35","height":"35","src":"../assets/img/profi_post_logo.png","alt":"Profi-Post.org"}}),_vm._v(" "),_c('b',[_vm._v("Profi-Post")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'breadcrumb',
    props: {
        list: {
            type: Array,
            required: true,
            default: function _default() {
                return [];
            }
        }
    },
    methods: {
        isLast: function isLast(index) {
            return index === this.list.length - 1;
        },
        showName: function showName(item) {
            if (item.meta && item.meta.label) {
                item = item.meta && item.meta.label;
            }
            if (item.name) {
                item = item.name;
            }
            return item;
        }
    }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a422125c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(356);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a422125c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'footer',
    data: function data() {
        return {
            year: new Date().getFullYear()
        };
    }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_vm._v("\n    Profi-Bank.org © "+_vm._s(_vm.year)+" "),_c('a',{attrs:{"href":"http://professional-group.org","target":"_blank"}},[_vm._v("SIIB Professional Group")]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"float-right"},[_c('a',{attrs:{"href":"http://prosperity.one","target":"_blank"}},[_vm._v("Consortium Prosperity SE")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61bd4a78_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(360);
function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61bd4a78_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumb_vue__ = __webpack_require__(114);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'header',
    components: {
        'header-breadcrumbs': __WEBPACK_IMPORTED_MODULE_0__Breadcrumb_vue__["a" /* default */]
    },
    data: function data() {
        return {};
    },

    computed: {
        breadcrumbs: function breadcrumbs() {
            return this.$route.matched;
        },
        avatar: function avatar() {
            return 'static/img/avatar.png';
        },
        rate: function rate() {
            return this.$store.state.finance['rate'].toFixed(4);
        },
        notifications: function notifications() {
            return this.$store.state.user['notifications'];
        },
        notificationsCount: function notificationsCount() {
            return this.notifications.length;
        },
        username: function username() {
            return this.$store.state.user['userdata']['username'];
        },
        fullname: function fullname() {
            return this.$store.state.user['userdata']['lastname'] + ' ' + this.$store.state.user['userdata']['firstname'];
        }
    },
    mounted: function mounted() {},

    methods: {
        sidebarToggle: function sidebarToggle(e) {
            e.preventDefault();
            document.body.classList.toggle('sidebar-hidden');
        },
        mobileSidebarToggle: function mobileSidebarToggle(e) {
            e.preventDefault();
            document.body.classList.toggle('sidebar-mobile-show');
        },
        asideToggle: function asideToggle(e) {
            e.preventDefault();
            document.body.classList.toggle('aside-menu-hidden');
        },
        logout: function logout() {
            this.$auth.logout({
                redirect: '/'
            });
        }
    }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_vm._v("\n        ☰\n    ")]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/"}}),_vm._v(" "),_c('header-breadcrumbs',{attrs:{"list":_vm.breadcrumbs}}),_vm._v(" "),_c('b-nav',{staticClass:"ml-auto",attrs:{"is-nav-bar":""}},[_c('div',{staticClass:"navbar-text mr-3"},[_c('span',{staticClass:"badge badge-info font-weight-normal"},[_vm._v("Банковский курс SPD: "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.rate))]),_vm._v(" "),_c('small',[_vm._v("EUR")])])]),_vm._v(" "),_c('b-nav-item',{staticClass:"d-md-down-none",attrs:{"hidden":""}},[_c('i',{staticClass:"icon-bell"}),(_vm.notificationsCount)?_c('span',{staticClass:"badge badge-pill badge-danger"},[_vm._v(_vm._s(_vm.notificationsCount))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"navbar-text"},[_vm._v("     ")]),_vm._v(" "),_c('span',{staticClass:"navbar-text"},[_vm._v(_vm._s(_vm.fullname)+"    ")]),_vm._v(" "),_c('img',{staticClass:"img-avatar",attrs:{"src":_vm.avatar,"alt":_vm.username}})],1),_vm._v(" "),_c('button',{staticClass:"navbar-toggler aside-menu-toggler d-md-down-none",staticStyle:{"display":"none"},attrs:{"type":"button"},on:{"click":_vm.asideToggle}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(361),"alt":"Profi-Planet"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = "../../static/img/profi_planet_logo.cd6b76a.png";

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ecb4096_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(381);
function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ecb4096_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navigation__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarFooter__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarNavDropdown__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavLink__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavTitle__ = __webpack_require__(378);









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar',
    data: function data() {
        return {
            navItems: __WEBPACK_IMPORTED_MODULE_0__navigation__["a" /* default */].items
        };
    },

    computed: {
        isAdmin: function isAdmin() {
            return this.$store.getters.isAdmin;
        },
        isFranchisee: function isFranchisee() {
            return this.$store.getters.isFranchisee;
        }
    },
    components: {
        SidebarFooter: __WEBPACK_IMPORTED_MODULE_1__SidebarFooter__["a" /* default */],
        SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
        SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_3__SidebarNavDropdown__["a" /* default */],
        SidebarNavLink: __WEBPACK_IMPORTED_MODULE_4__SidebarNavLink__["a" /* default */],
        SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_5__SidebarNavTitle__["a" /* default */]
    },
    methods: {
        handleClick: function handleClick(e) {
            e.preventDefault();
            e.target.parentElement.classList.toggle('open');
        }
    }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var navigation = {
    items: [{
        title: true,
        name: 'Меню'
    }, {
        name: 'Сводка',
        url: {
            name: 'Dashboard'
        },
        icon: 'fa fa-cubes'
    }, {
        name: 'Профиль',
        url: {
            name: 'Profile'
        },
        icon: 'fa fa-user'
    }, {
        name: 'Финансы',
        url: {
            name: 'Finance'
        },
        icon: 'fa fa-money',
        children: [{
            name: 'Счета',
            url: {
                name: 'FinanceAccounts'
            },
            icon: ''
        }, {
            name: 'История',
            url: {
                name: 'FinanceHistory'
            },
            icon: ''
        }]
    }, {
        title: true,
        name: 'Займы'
    }, {
        name: 'Депозиты',
        url: {
            name: 'Deposits'
        },
        icon: 'fa fa-shopping-bag'
    }, {
        name: 'Кредиты',
        url: {
            name: 'Credits'
        },
        icon: 'fa fa-percent'
    }, {
        title: true,
        name: 'Дополнительно'
    }, {
        name: 'Сотрудникам',
        url: {
            name: 'Franchising'
        },
        icon: 'fa fa-users',
        badge: {
            variant: 'primary',
            text: '!'
        },
        franchisee: true,
        children: [{
            name: 'Франшизы',
            url: {
                name: 'FranchisingFranchisee'
            },
            icon: 'fa fa-users2'
        }, {
            name: 'Маркетинг',
            url: {
                name: 'FranchisingMarketing'
            },
            icon: 'fa fa-users2'
        }]
    }, {
        divider: true
    }, {
        name: 'Админка',
        url: {
            name: 'Admin'
        },
        icon: 'fa fa-admin',
        admin: true,
        children: [{
            name: 'Сводка',
            url: {
                name: 'AdminDashboard'
            },
            icon: ''
        }, {
            name: 'Заказы',
            url: {
                name: 'AdminOrders'
            },
            icon: ''
        }]
    }, {
        divider: true
    }, {
        name: 'Выход',
        url: {
            name: 'AuthLogout'
        },
        icon: 'fa fa-sign-out'
    }]
};

/* harmony default export */ __webpack_exports__["a"] = (navigation);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69cfa230_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(368);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69cfa230_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-footer'
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9fbf3bc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(371);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9fbf3bc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-header'
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31958d8f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(374);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31958d8f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        name: {
            type: String,
            default: ''
        },
        url: {
            type: [String, Object],
            default: ''
        },
        icon: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleClick: function handleClick(e) {
            e.preventDefault();
            e.target.parentElement.classList.toggle('open');
        }
    }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84130010_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(377);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84130010_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'sidebar-nav-link',
    props: {
        name: {
            type: String,
            default: ''
        },
        url: {
            type: [String, Object],
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        badge: {
            default: ''
        }
    },
    mounted: function mounted() {},

    computed: {
        confirm: function confirm() {
            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.url));
        }
    }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-link",attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3604e96c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(380);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3604e96c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        name: {
            type: String,
            default: ''
        },
        classes: {
            type: String,
            default: ''
        },
        wrapper: {
            type: Object,
            default: function _default() {}
        }
    }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-title",class:_vm.classes},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n            "+_vm._s(_vm.name)+"\n        ")])]:[_vm._v("\n        "+_vm._s(_vm.name)+"\n    ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children && (!item.admin || (item.admin && _vm.isAdmin)) && (!item.franchisee || (item.franchisee && _vm.isFranchisee)))?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge}})],1)}))]:[_c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge}})],1)]]})],2)]:(!item.admin || (item.admin && _vm.isAdmin))?[_c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge}})],1)]:_vm._e()]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_448f83eb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(384);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_448f83eb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    model: {
        prop: 'checked',
        event: 'change'
    },
    props: {
        value: {
            default: true
        },
        uncheckedValue: {
            default: false
        },
        checked: {
            default: false
        },
        type: {
            type: String,
            default: 'default'
        },
        variant: {
            type: String,
            default: ''
        },
        pill: {
            type: Boolean,
            default: false
        },
        on: {
            type: String,
            default: null
        },
        off: {
            type: String,
            default: null
        },
        size: {
            type: String,
            default: null
        }
    },
    computed: {
        classList: function classList() {
            return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
        },
        switchType: function switchType() {
            return this.type ? 'switch-' + this.type : 'switch-default';
        },
        switchVariant: function switchVariant() {
            return this.variant ? 'switch-' + this.variant : 'switch-secondary';
        },
        switchPill: function switchPill() {
            return !this.pill ? null : 'switch-pill';
        },
        switchSize: function switchSize() {
            return this.size ? 'switch-' + this.size : '';
        },
        isChecked: function isChecked() {
            return this.checked === this.value;
        },
        isOn: function isOn() {
            return !this.on ? null : true;
        }
    },
    methods: {
        handleChange: function handleChange(_ref) {
            var checked = _ref.target.checked;

            this.$emit('change', checked ? this.value : this.uncheckedValue);
        }
    }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('vue-toastr',{ref:"toastr"}),_vm._v(" "),_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('AppSidebar'),_vm._v(" "),_c('router-view',{staticClass:"main"})],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea566a3_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__(389);
function injectStyle (ssrContext) {
  __webpack_require__(387)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ea566a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea566a3_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Auth'
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth animated fadeIn"},[_c('b-container',{staticClass:"app"},[_c('b-row',{attrs:{"align-v":"center","align-h":"center"}},[_c('b-col',{staticClass:"mt-5",attrs:{"cols":"9"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirmation_vue__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_678218a0_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmation_vue__ = __webpack_require__(396);
function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-678218a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_678218a0_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__ = __webpack_require__(16);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'confirmation',

    data: function data() {
        return {
            isLoading: true
        };
    },


    components: {
        'data-loading': __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__["a" /* default */]
    }
});

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'data-loading'
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cssload-loader"},[_c('div',{staticClass:"cssload-inner cssload-one"}),_vm._v(" "),_c('div',{staticClass:"cssload-inner cssload-two"}),_vm._v(" "),_c('div',{staticClass:"cssload-inner cssload-three"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirmation animated fadeIn"},[(_vm.isLoading)?_c('div',{staticClass:"app"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('data-loading',{staticClass:"my-5"})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col'),_vm._v(" "),_c('b-col',[_c('b-alert',{staticClass:"text-center font-weight-bold small m-3",attrs:{"show":"","variant":"primary"}},[_vm._v("Идет обработка запроса...")])],1),_vm._v(" "),_c('b-col')],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app"},[_c('b-row',{attrs:{"align-v":"center","align-h":"center"}},[_c('b-col',{staticClass:"mt-5",attrs:{"cols":"9"}},[_c('router-view',{on:{"dataLoaded":function($event){_vm.isLoading = false;}}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371f8fb8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__(399);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371f8fb8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'error-404'
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! You're lost.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for was not found.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Frontend_vue__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b160c25_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Frontend_vue__ = __webpack_require__(403);
function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Frontend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b160c25_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Frontend_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'frontend',
    data: function data() {
        return {
            feedback: {
                name: '',
                email: '',
                message: ''
            }
        };
    },

    computed: {
        isFeedbackFormValid: function isFeedbackFormValid() {
            return this.feedback.name && this.feedback.email && this.feedback.message;
        }
    },
    methods: {
        scrollTo: function scrollTo(refName) {
            var element = this.$refs[refName];
            window.scrollTo(0, element.offsetTop);
        },
        sendFeedback: function sendFeedback() {
            console.log(this.feedback);
        }
    }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",staticClass:"frontend"},[_c('div',{staticClass:"banner"}),_vm._v(" "),_c('div',{staticClass:"header"},[_c('b-container',[_c('b-row',[_c('b-col',[_c('b-navbar',{attrs:{"toggleable":"md"}},[_c('b-nav-toggle',{attrs:{"target":"bank-navbar-collapse"}}),_vm._v(" "),_c('b-navbar-brand',[_c('h1',[_vm._v("Profi "),_c('span',[_vm._v("Bank")])])]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"bank-navbar-collapse"}},[_c('b-nav',{staticClass:"ml-auto",attrs:{"is-nav-bar":""}},[_c('b-nav-item',{attrs:{"href":"/"},on:{"click":function($event){$event.preventDefault();_vm.scrollTo('main')}}},[_vm._v("Главная")]),_vm._v(" "),_c('b-nav-item',{attrs:{"href":"#about"},on:{"click":function($event){$event.preventDefault();_vm.scrollTo('about')}}},[_vm._v("О нас")]),_vm._v(" "),_c('b-nav-item',{attrs:{"href":"#services"},on:{"click":function($event){$event.preventDefault();_vm.scrollTo('services')}}},[_vm._v("Услуги")]),_vm._v(" "),_c('b-nav-item',{attrs:{"href":"#opportunities"},on:{"click":function($event){$event.preventDefault();_vm.scrollTo('opportunities')}}},[_vm._v("Возможности")]),_vm._v(" "),_c('b-nav-item',{attrs:{"href":"#partnership"},on:{"click":function($event){$event.preventDefault();_vm.scrollTo('partnership')}}},[_vm._v("Партнерам")]),_vm._v(" "),_c('b-nav-item',{attrs:{"href":"#contacts"},on:{"click":function($event){$event.preventDefault();_vm.scrollTo('contacts')}}},[_vm._v("Контакты")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{name: 'Cabinet'}}},[_vm._v("Кабинет")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('ul',{staticClass:"slider"},[_c('li',{staticClass:"slide slide-1 jarallax"},[_c('b-container',[_c('h3',[_c('span',[_vm._v("Единая платежная система")])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('span',[_vm._v("Возможность контролировать все платежи сервисов Profi-Planet в одном месте")])])])],1)]),_vm._v(" "),_c('b-container',{staticClass:"content px-0"},[_c('b-row',{ref:"welcome"},[_c('b-col',[_c('h2',[_vm._v("Добро пожаловать!")]),_vm._v(" "),_c('p',[_vm._v("Мы с достоинством и гордостью приветствуем вас в «Profi Bank» — это внутри корпоративный расчетно-кассовый центр (РКЦ), призванный обеспечить удобство взаиморасчетов между компаниями, сервисами, услугами, имеющими место в Консорциуме Prosperity SE, а также между входящими в него организациями и их клиентами, партнерами и контрагентами.")]),_vm._v(" "),_c('p',[_vm._v("«Profi Bank» также является кредитной организацией, стремящейся в корне преобразовать отрасль интернет-бизнеса.")]),_vm._v(" "),_c('p',[_vm._v("«Profi Bank» вместе с Вами создает революцию в преобразовании интеллектуального труда для ключевых профессий электронной коммерции (полный список видов деятельности, указан в разделе "),_c('a',{attrs:{"href":"http://spooo.ru/leagues","target":"_blank"}},[_vm._v("«Лиги»")]),_vm._v(" социальной сети Spooo.biz — одной из сторон проекта), а также для промышленности, строительства, туризма, и различных форм фриланса.")]),_vm._v(" "),_c('p',[_vm._v("Деятельность «Profi Bank» основана на создаваемой им инновационной модели «mind banking» © (умный банкинг), когда субъекты социума обменивают время интеллектуального труда на товары и услуги. Разве не к этому стремится общество все время своего существования?")]),_vm._v(" "),_c('p',[_vm._v("Мы искренне надеемся, что Вы станете нашим постоянным клиентом, а бережно созданные нами услуги станут для Вас незаменимым инструментом.")])])],1),_vm._v(" "),_c('b-row',{ref:"about"},[_c('b-col',[_c('h2',[_vm._v("О нас")]),_vm._v(" "),_c('p',[_vm._v("«Profi Bank» является управляющим органом корпоративной валюты spound (спаунд, или спунт по аналогии с pound-фунт), однако, «Profi Bank» не является ее эмитентом и не контролирует эмиссию.")]),_vm._v(" "),_c('p',[_vm._v("Функции эмитента несет социальная сеть Spooo.biz. Именно в соцсети происходит майнинг спаунда, который производят участники соцсети (spooo-тники) посредством "),_c('a',{attrs:{"href":"http://spooo.biz/page/actions","target":"_blank"}},[_vm._v("различного рода действий")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Функции курсового регулятора несет Биржа, которая по законам спроса и предложения валюты устанавливает рыночный курс спаунда (SP).")]),_vm._v(" "),_c('p',[_vm._v("Весь объем валюты соответствует объему интеллектуального производного социальной сети. Внутрикорпоративная валюта спаунд обеспечена услугами, оказываемыми населению, и товарами, производимыми группой компаний Prosperity SE.")]),_vm._v(" "),_c('p',[_vm._v("На самом первом этапе еще три участника данной системы обеспечивают валюту товарным наполнением, это:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("востребованные интернет-сервисы (Spooo, Profi-Post, Profi-Link, Profi-Host, Profi-Meet, eTerra Digest)")]),_vm._v(" "),_c('li',[_vm._v("торгово-промышленная площадка Profi-Shop с огромным ассортиментом товаров и услуг")]),_vm._v(" "),_c('li',[_vm._v("Prosperity-Life (услуги туризма и Средземноморская недвижимость)")])]),_vm._v(" "),_c('p',[_vm._v("«Profi Bank» — внутрикорпоративный Банк Консорциума Prosperity SE покупает у населения криптовалюту sPound (спунт), которую люди производят, создавая контент в социальной сети Spooo.biz.")]),_vm._v(" "),_c('p',[_vm._v("Spound (SP) — валюта, изначально обеспеченная человеческим трудом (знания, опыт, интеллект, время, труд, мысли, тексты, изображения, эмоции, мнения).")]),_vm._v(" "),_c('p',[_vm._v("Чем больше пользователей социальной сети Spooo, чем они активнее трудятся, создавая контент, тем больше валюты поступает в банк, а значит, банк сможет предоставлять всё более и более высокие процентные ставки по депозитам.")]),_vm._v(" "),_c('p',[_vm._v("Схема валютного регулирования проста и изящна:"),_c('br'),_vm._v("\n                    много желающих иметь высокодоходный депозит в спаундах => много пользователей в сети Spooo, производящих SP => много спунтов в экономической системе => все это позволяет организовать высокие ставки по депозитам.")]),_vm._v(" "),_c('p',[_vm._v("Общее количество товаров и услуг наращивается по мере развития валюты. Данный процесс взаимообразный, и товарный объем нарастает настолько, насколько он обеспечивается майнинговой эмиссией.")])])],1),_vm._v(" "),_c('b-row',{ref:"services"},[_c('b-col',[_c('h2',[_vm._v("Услуги")]),_vm._v(" "),_c('p',[_vm._v("«Profi Bank» осуществляет следующие услуги:")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("Расчетно-кассовые операции со всеми дружественными компаниями, сервисами, услугами, товарами. Через РКЦ (расчетно-кассовый центр) упрощаются и стандартизируются все взаиморасчёты между сервисами и клиентами, компаниями и партнерами")]),_vm._v(" "),_c('li',[_vm._v("Обменные операции с SP")]),_vm._v(" "),_c('li',[_vm._v("Открывает высокодоходные депозиты с выгодными процентными ставками в SP")]),_vm._v(" "),_c('li',[_vm._v("Принимает депозиты в EURO с увеличенными процентными ставками")]),_vm._v(" "),_c('li',[_vm._v("Инвестирует в предприятия и высокодоходные проекты в международной недвижимости и туризме, облигации и прямое инвестирование доходных проектов и сделок")]),_vm._v(" "),_c('li',[_vm._v("Финансирует деятельность региональных представителей на условиях франшизы.")])])])],1),_vm._v(" "),_c('b-row',{ref:"opportunities"},[_c('b-col',[_c('h2',[_vm._v("Уникальные возможности для клиентов «Profi Bank»")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Высокие процентные ставки по вкладам в спаундах (SP) гарантируются компаниями-учредителями «Profi Bank»")]),_vm._v(" "),_c('li',[_vm._v("Взвешенный подход к капитализации:\n                        "),_c('ul',[_c('li',[_vm._v("чем больше пользователей соцсети Spooo, тем больше они создают информационного контента, тем больше майнинг SP.")]),_vm._v(" "),_c('li',[_vm._v("растущее количество спаундов уравновешивается ростом спроса на них, в связи с ростом числа пользователей Spooo и увеличением товаров и услуг, реализуемых за спаунды.")])])]),_vm._v(" "),_c('li',[_vm._v("Высокие процентные ставки по вкладам в Евро, зависят только от размеров вклада, без учета срока депозита")]),_vm._v(" "),_c('li',[_vm._v("«Profi Bank» является внутренним банком компаний-учредителей и на его работу не влияют кризисы в международной валютной системе")]),_vm._v(" "),_c('li',[_vm._v("sPound торгуется на внутренней бирже «Profi Bank» независимо от биржи социальной сети Spooo.biz")]),_vm._v(" "),_c('li',[_vm._v("sPound обеспечен услугами, сервисами и продуктами Корпорации SIIB Professional Group и Консорциума Prosperity SE")]),_vm._v(" "),_c('li',[_vm._v("sPound могут принимать все желающие, для этого достаточно выставить свой товар на торгово-промышленной площадке")]),_vm._v(" "),_c('li',[_vm._v("Курс SP привязывается к биржевой котировке. Услуги, сервисы и товары, предлагаемые на торгово-промышленной площадке, торгуются в SP по курсу биржи «Profi Bank»")])])])],1),_vm._v(" "),_c('b-row',{ref:"partnership"},[_c('b-col',[_c('h2',[_vm._v("Уникальная возможность стать партнером «Profi Bank»")]),_vm._v(" "),_c('p',[_vm._v("Мы предлагаем партнерство юридическим лицам, организациям и индивидуальным предпринимателям.")]),_vm._v(" "),_c('p',[_vm._v("Выгоды для предпринимателей и интернет-магазинов от сотрудничества с «Profi Bank»:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Открытие анонимных счетов и депозитов (принцип Швейцарских банков)")]),_vm._v(" "),_c('li',[_vm._v("Беспроцентная кредитная линия без залога с ежемесячным погашением. Корпоративный клиент может получать выписку с депозита о том, что у него есть такая сумма на счету. Это можно использовать для участия в торгах, тендерах, бизнес-проектах, требующих доказательств состоятельности партнера.")]),_vm._v(" "),_c('li',[_vm._v("Кредит в евро без залога. Позволяет приобретать спаунды и выставлять их на Бирже, покупать франшизы, вложить в любой бизнес: оплачивать товары и услуги консорциума Prosperity SE (рекламу, хостинг, статьи, рассылку, франшизы). По окончании кредитного периода полученную прибыль клиент может выводить на любые счета любой страны.")]),_vm._v(" "),_c('li',[_vm._v("Организации, принимающие спаунды к оплате, на 1 год освобождаются от оплаты услуг банка по всем транзакциям")]),_vm._v(" "),_c('li',[_vm._v("Ваш товар или услуга приобретают дополнительную ценность и стоимость. Spound твердая валюта, и оборачивая средства по схеме клиент(товар)-спаунд-биржа-евро вы удваиваете стоимость товаров и услуг помимо простой торговой надбавки")]),_vm._v(" "),_c('li',[_vm._v("Мы рекламируем вашу компанию и ваш товар на сайте «Profi Bank»")]),_vm._v(" "),_c('li',[_vm._v("Вы получаете дополнительный рынок клиентов социальной сети Spooo.ru и всех клиентов «Profi Bank»")]),_vm._v(" "),_c('li',[_vm._v("Крупные постоянные корпоративные клиенты кредитуются в «Profi Bank» на особенно выгодных условиях")])])])],1),_vm._v(" "),_c('b-row',{ref:"contacts"},[_c('b-col',[_c('h2',[_vm._v("Контакты")]),_vm._v(" "),_c('b-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"1"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.sendFeedback($event)}}},[_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"Ваше имя"},model:{value:(_vm.feedback.name),callback:function ($$v) {_vm.feedback.name=$$v},expression:"feedback.name"}})],1),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"placeholder":"Ваш e-mail адрес","type":"email"},model:{value:(_vm.feedback.email),callback:function ($$v) {_vm.feedback.email=$$v},expression:"feedback.email"}})],1),_vm._v(" "),_c('b-form-group',[_c('b-form-textarea',{attrs:{"placeholder":"Сообщение","rows":8},model:{value:(_vm.feedback.message),callback:function ($$v) {_vm.feedback.message=$$v},expression:"feedback.message"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"form-actions text-right"},[_c('b-button',{staticClass:"px-4",attrs:{"type":"submit","variant":"primary","disabled":!_vm.isFeedbackFormValid}},[_vm._v("Отправить")])],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('h5',[_vm._v("Напишите нам")]),_vm._v(" "),_c('p',[_vm._v("Если у Вас возникли дополнительные вопросы, либо Вы хотите отправить свои комментарии, замечания или предложения, пожалуйста, воспользуйтесь формой обратной связи слева или отправьте email-сообщение по адресу "),_c('a',{attrs:{"href":"mailto:reception@profi-bank.org"}},[_vm._v("reception@profi-bank.org")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Мы ответим на Ваше сообщение в сроки, необходимые для подготовки ответа и/или проведения разбирательств.")]),_vm._v(" "),_c('p',{staticClass:"text-danger"},[_c('small',[_vm._v("При отправке электронного сообщения Вы автоматически подтверждаете свое "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.agreement",modifiers:{"agreement":true}}],staticClass:"text-danger",attrs:{"href":"#agreement"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("согласие на обработку персональных данных")]),_vm._v(".")])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"agreement","title":"Согласие на обработку персональных данных","size":"lg","ok-only":true}},[_c('p',[_vm._v("В соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных», я свободно, своей волей и в своем интересе даю согласие на осуществление «Profi Bank» (далее – Банк), обработки указанных в настоящем обращении моих персональных данных (сбора, записи, систематизации, накопления, хранения, уточнения (обновления, изменения), извлечения, использования, передачи, обезличивания, блокирования и уничтожения) с использованием/без использования средств автоматизации в целях обработки настоящего электронного обращения и направления/ предоставления ответа.")]),_vm._v(" "),_c('p',[_vm._v("Согласие предоставляется с момента оформления настоящего обращения и действительно в течение срока, предусмотренного действующим законодательством Российской Федерации.")]),_vm._v(" "),_c('p',[_vm._v("Я уведомлен(-на), что согласие на обработку персональных данных может быть отозвано в соответствии с ч. 2 ст. 9 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных». В случае отзыва согласия на обработку персональных данных Банк вправе продолжить обработку персональных данных без моего согласия при наличии оснований, указанных в п. 2-11 ч. 1 ст. 6, ч. 2 ст. 10, ч. 2 ст. 11 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».")]),_vm._v(" "),_c('p',[_vm._v("Согласен(-на) с тем, что Банк в целях уточнения информации, содержащейся в обращении, и информирования о ходе рассмотрения настоящего обращения может использовать сведения, содержащиеся в настоящем электронном обращении.")]),_vm._v(" "),_c('p',[_vm._v("Банк доводит Вашего сведения, что электронные обращения, направленные через сеть Интернет, передаются по незащищенным каналам связи. Банк не несет ответственности за сохранение конфиденциальности данных при их передаче через сеть Интернет.")])])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"copyright"},[_c('p',{staticClass:"mt-0 small"},[_c('i',{staticClass:"fa fa-envelope-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{attrs:{"href":"mailto:reception@profi-bank.org"}},[_vm._v("reception@profi-bank.org")])]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("© 2017 Profi-Bank.org. All rights reserved "),_c('small',{staticClass:"pull-right"},[_vm._v("Part of "),_c('a',{attrs:{"href":"http://prosperity.one","target":"_blank"}},[_vm._v("Consortium Prosperity SE")])])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e28ac3de_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(407);
function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e28ac3de_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_toastr__);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dashboard',
    components: {
        'data-loading': __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__["a" /* default */],
        'vue-toastr': __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default.a
    },
    data: function data() {
        return {
            loading: false,

            balance: {
                eur: 0,
                spd: 0
            },
            deposits: {
                eur: 0,
                spd: 0
            },
            referrals: {
                today: 0,
                total: 0
            },
            franchises: {
                agent: 0,
                supervisor: 0
            },
            lastPayments: []
        };
    },
    mounted: function mounted() {
        this.loadData();
    },

    methods: {
        loadData: function loadData() {
            var _this = this;

            this.loading = true;

            this.axios.get('users/summary').then(function (response) {
                _this.balance = response.data['balance'];

                if (response.data.hasOwnProperty('message') && response.data['message']) {
                    _this.$refs['toastr'].i(response.data['message']);
                }

                setTimeout(function () {
                    _this.loading = false;
                }, 500);
            }).catch(function () {
                _this.$refs['toastr'].e('Произошла ошибка');
            });
        }
    }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('vue-toastr',{ref:"toastr"}),_vm._v(" "),_c('div',{class:{blur: _vm.loading}},[_c('b-row',[_c('b-col',{attrs:{"cols":"3"}},[_c('div',{staticClass:"social-box balance"},[_c('i',{staticClass:"fa fa-money"}),_vm._v(" "),_c('h5',[_vm._v("Мой баланс")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.balance.eur))]),_vm._v(" "),_c('span',[_vm._v("EUR")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.balance.spd))]),_vm._v(" "),_c('span',[_vm._v("SPD")])])])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('div',{staticClass:"social-box deposits"},[_c('i',{staticClass:"fa fa-shopping-bag"}),_vm._v(" "),_c('h5',[_vm._v("Мои депозиты")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.deposits.eur))]),_vm._v(" "),_c('span',[_vm._v("EUR")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.deposits.spd))]),_vm._v(" "),_c('span',[_vm._v("SPD")])])])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('div',{staticClass:"social-box referrals"},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('h5',[_vm._v("Мои клиенты")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.balance.eur))]),_vm._v(" "),_c('span',[_vm._v("Сегодня")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.balance.spd))]),_vm._v(" "),_c('span',[_vm._v("Всего")])])])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('div',{staticClass:"social-box franchises"},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('h5',[_vm._v("Мои франшизы")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.balance.eur))]),_vm._v(" "),_c('span',[_vm._v("Агент")])]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.balance.spd))]),_vm._v(" "),_c('span',[_vm._v("Супервайзер")])])])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-table',{staticClass:"table-outline",attrs:{"items":_vm.lastPayments}})],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('data-loading')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f761fe6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(410);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f761fe6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'profile',
    data: function data() {
        return {
            userdata: {
                lastname: '',
                firstname: '',
                email: '',
                username: '',
                skype: '',
                birthdate: '',
                phone: '',
                country: '',
                city: '',
                address: ''
            },
            editable: false
        };
    },
    mounted: function mounted() {
        this.initUserdata();
    },

    methods: {
        initUserdata: function initUserdata() {
            var userdata = this.$store.state.user['userdata'];

            this.userdata.lastname = userdata.lastname;
            this.userdata.firstname = userdata.firstname;
            this.userdata.email = userdata.email;
            this.userdata.username = userdata.username;
            this.userdata.skype = userdata.skype;
        },
        changeUserdata: function changeUserdata() {
            this.editable = true;
        },
        updateUserdata: function updateUserdata() {
            this.initUserdata();
            this.editable = false;
        },
        changePassword: function changePassword() {}
    }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b-card',[_c('h5',[_vm._v("Информация")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.updateUserdata()}}},[_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":"Фамилия","label-for":"profile-lastname"}},[_c('b-form-input',{attrs:{"id":"profile-lastname","readonly":!_vm.editable},model:{value:(_vm.userdata.lastname),callback:function ($$v) {_vm.userdata.lastname=$$v},expression:"userdata.lastname"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":"Имя","label-for":"profile-firstname"}},[_c('b-form-input',{attrs:{"id":"profile-firstname","readonly":!_vm.editable},model:{value:(_vm.userdata.firstname),callback:function ($$v) {_vm.userdata.firstname=$$v},expression:"userdata.firstname"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":"E-Mail","label-for":"profile-email"}},[_c('b-form-input',{attrs:{"id":"profile-email","plaintext_":!_vm.editable,"readonly":""},model:{value:(_vm.userdata.email),callback:function ($$v) {_vm.userdata.email=$$v},expression:"userdata.email"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":"Логин","label-for":"profile-username"}},[_c('b-form-input',{attrs:{"id":"profile-username","plaintext_":!_vm.editable,"readonly":""},model:{value:(_vm.userdata.username),callback:function ($$v) {_vm.userdata.username=$$v},expression:"userdata.username"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":"Skype","label-for":"profile-skype"}},[_c('b-form-input',{attrs:{"id":"profile-skype","readonly":!_vm.editable},model:{value:(_vm.userdata.skype),callback:function ($$v) {_vm.userdata.skype=$$v},expression:"userdata.skype"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}})],1),_vm._v(" "),(_vm.editable)?_c('b-button',{attrs:{"type":"submit","disabled":"","variant":"primary"}},[_vm._v("Сохранить")]):_vm._e(),_vm._v(" "),(_vm.editable)?_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.editable = !_vm.editable; _vm.initUserdata()}}},[_vm._v("Отмена")]):_vm._e(),_vm._v(" "),(!_vm.editable)?_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){$event.preventDefault();_vm.changeUserdata()}}},[_vm._v("Изменить")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4","hidden":""}},[_c('b-card',[_c('h5',[_vm._v("Смена пароля")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.changePassword($event)}}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Finance_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_356b6597_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Finance_vue__ = __webpack_require__(413);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Finance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_356b6597_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Finance_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'finance'
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Accounts_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dccd2e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Accounts_vue__ = __webpack_require__(416);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Accounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04dccd2e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Accounts_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_toastr__);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'finance-accounts',
    components: {
        'data-loading': __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__["a" /* default */],
        'vue-toastr': __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default.a
    },
    data: function data() {
        return {
            accounts: [],
            accountsFields: {
                id: {
                    label: '#',
                    tdClass: 'small'
                },
                currency: {
                    label: 'Валюта',
                    tdClass: 'small'
                },
                amount: {
                    label: 'Остаток'
                }
            },
            loading: false
        };
    },
    mounted: function mounted() {
        this.loadAccounts();
    },

    methods: {
        loadAccounts: function loadAccounts() {
            var _this = this;

            this.loading = true;
            this.axios.get('finance/accounts').then(function (response) {
                _this.accounts = response.data['accounts'];

                if (response.data.hasOwnProperty('message') && response.data['message']) {
                    _this.$refs['toastr'].i(response.data['message']);
                }

                setTimeout(function () {
                    _this.loading = false;
                }, 500);
            }).catch(function () {
                _this.$refs['toastr'].e('Произошла ошибка');
            });
        }
    }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('vue-toastr',{ref:"toastr"}),_vm._v(" "),_c('div',{class:{blur: _vm.loading}},[_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"title":"Мои счета"}},[_c('b-table',{attrs:{"items":_vm.accounts,"fields":_vm.accountsFields}})],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('data-loading')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec31508_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__(419);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ec31508_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_toastr__);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'finance-history',
    components: {
        'data-loading': __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__["a" /* default */],
        'vue-toastr': __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default.a
    },
    data: function data() {
        return {
            loading: false,

            payments: [],
            historyFields: {
                date: {
                    label: 'Дата',
                    tdClass: 'small'
                },
                amount: {
                    label: 'Сумма',
                    formatter: function formatter(amount) {
                        return '€ ' + amount;
                    }
                },
                service: {
                    label: 'Сервис',
                    tdClass: 'small',
                    formatter: function formatter(service) {
                        var result = void 0;

                        switch (service) {
                            case 'post':
                                result = 'Profi-Post.org';
                                break;
                            case 'host':
                                result = 'Profi-Host.org';
                                break;
                            case 'link':
                                result = 'Profi-Link.org';
                                break;
                            case 'spooo':
                                result = 'Spooo.ru';
                                break;
                            case 'eterra':
                                result = 'eTerra.info';
                                break;
                            default:
                                result = service;
                        }

                        return result;
                    }
                },
                method: {
                    label: 'Платежный шлюз',
                    tdClass: 'small',
                    formatter: function formatter(service) {
                        var result = void 0;

                        switch (service) {
                            case 'robokassa':
                                result = 'RoboKassa';
                                break;
                            case 'wm':
                                result = 'WebMoney';
                                break;
                            default:
                                result = '';
                        }

                        return result;
                    }
                },
                comment: {
                    label: 'Примечание'
                }
            }
        };
    },

    computed: {
        hasPayments: function hasPayments() {
            return this.payments.length > 0;
        }
    },
    mounted: function mounted() {
        this.loadHistory();
    },

    methods: {
        loadHistory: function loadHistory() {
            var _this = this;

            this.loading = true;

            this.axios.get('finance/history').then(function (response) {
                _this.payments = response.data['history'];

                if (response.data.hasOwnProperty('message') && response.data['message']) {
                    _this.$refs['toastr'].i(response.data['message']);
                }

                setTimeout(function () {
                    _this.loading = false;
                }, 500);
            }).catch(function () {
                _this.$refs['toastr'].e('Произошла ошибка');
            });
        }
    }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('vue-toastr',{ref:"toastr"}),_vm._v(" "),_c('div',{class:{blur: _vm.loading}},[_c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"variant":"warning","show":""}},[_c('b',[_vm._v("Внимание!")]),_vm._v(" "),_c('span',{staticClass:"small"},[_vm._v("Идет консолидация финансовой информации с другими серсвиами. На этапе консолидации возможно отображение не всей информации о платежах.")])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"title":"Последние платежи"}},[(_vm.hasPayments)?_c('b-table',{attrs:{"items":_vm.payments,"fields":_vm.historyFields}}):_c('p',[_vm._v("\n                        Платежей нет\n                    ")])],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('data-loading')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deposits_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6bc228_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Deposits_vue__ = __webpack_require__(425);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deposits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b6bc228_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Deposits_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Payment_vue__ = __webpack_require__(115);






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'deposits',
    components: {
        'data-loading': __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__["a" /* default */],
        'vue-toastr': __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default.a,
        'modal-payment': __WEBPACK_IMPORTED_MODULE_2__components_Payment_vue__["a" /* default */]
    },
    data: function data() {
        return {
            loading: false,
            deposit: {
                amount: 200,
                currency: 'EUR',
                period: 3
            },
            currencies: [{
                value: 'SPD',
                text: 'SPD'
            }, {
                value: 'EUR',
                text: 'EUR'
            }],
            periods: [{
                value: 1,
                text: '1 месяц'
            }, {
                value: 3,
                text: '3 месяца'
            }, {
                value: 6,
                text: '6 месяцев'
            }, {
                value: 9,
                text: '9 месяцев'
            }, {
                value: 12,
                text: '1 год'
            }],
            depositTypes: {
                'EUR': [],
                'SPD': []
            },

            depositOrders: [],
            depositOrdersFields: {
                amount: {
                    label: 'Сумма',
                    tdClass: 'small'
                },
                interest: {
                    label: '%',
                    tdClass: 'small'
                },
                total: {
                    label: 'Вознаграждение за месяц',
                    tdClass: 'small'
                },
                date: {
                    label: 'Дата заказа',

                    tdClass: 'small'
                },
                paid: {
                    label: '',

                    tdClass: 'small',
                    formatter: function formatter(value) {
                        if (value) {
                            return value;
                        }
                        return '';
                    }
                }
            },

            paymentOrderId: null
        };
    },

    computed: {
        interest: function interest() {
            var _this = this;

            var result = void 0;
            this.depositTypes[this.deposit.currency].forEach(function (depositType) {
                if (_this.deposit.currency === depositType['currency'] && _this.deposit.amount >= depositType['minimalAmount']) {
                    result = result ? result < depositType.interest ? depositType.interest : result : depositType.interest;
                }
            });

            return result;
        },
        isSPDSelected: function isSPDSelected() {
            return this.deposit.currency === 'SPD';
        },
        totalAmount: function totalAmount() {
            var total = this.deposit.amount * this.interest / 100;

            return (this.deposit.amount + total / 12 * this.deposit.period).toFixed(2);
        },
        hasDepositOrders: function hasDepositOrders() {
            return this.depositOrders.length > 0;
        }
    },
    mounted: function mounted() {
        this.loadDepositsData();
        this.loadDepositOrders();
    },

    methods: {
        onlyDigits: function onlyDigits(value, event) {
            if (isNaN(parseInt(event.data)) || event.data === '.' || event.data === '') {}
            return value;
        },
        periodTitle: function periodTitle(period) {
            var result = void 0;

            result = this.periods.filter(function (item) {
                return item.value === period;
            });

            if (result.length === 0) {
                result = 0;
            } else {
                result = result[0]['text'];
            }

            return result;
        },
        formatMoney: function formatMoney(num, currency, c, d, t) {
            var n = num;
            c = isNaN(c = Math.abs(c)) ? 2 : c;
            d = d === undefined ? '.' : d;
            t = t === undefined ? '&nbsp;' : t;
            var s = n < 0 ? '-' : '';
            var i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c)));
            var j = i.length;
            j = j > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '') + '&nbsp;<small>' + currency + '</small>';
        },
        loadDepositOrders: function loadDepositOrders() {
            var _this2 = this;

            this.loading = true;
            this.axios.get('deposits/orders').then(function (response) {
                _this2.depositOrders = response.data['orders'];

                if (response.data.hasOwnProperty('message') && response.data['message']) {
                    _this2.$refs['toastr'].i(response.data['message']);
                }

                setTimeout(function () {
                    _this2.loading = false;
                }, 500);
            }).catch(function () {
                _this2.$refs['toastr'].e('Произошла ошибка');
                _this2.loading = false;
            });
        },
        openDeposit: function openDeposit() {
            var _this3 = this;

            if (this.deposit.currency === 'SPD') {
                this.$refs['toastr'].w('Открытие депозитов в SPD приостановлено на время осуществления ICO');
                return;
            }
            this.loading = true;

            this.axios.post('deposits/open', this.deposit).then(function (response) {
                _this3.depositOrders.unshift(response.data['order']);

                if (response.data.hasOwnProperty('message') && response.data['message']) {
                    _this3.$refs['toastr'].i(response.data['message']);
                }

                setTimeout(function () {
                    _this3.loading = false;
                }, 500);
            }).catch(function () {
                _this3.$refs['toastr'].e('Произошла ошибка');
                setTimeout(function () {
                    _this3.loading = false;
                }, 500);
            });
        },
        loadDepositsData: function loadDepositsData() {
            var _this4 = this;

            this.loading = true;

            this.axios.get('deposits/types').then(function (response) {
                _this4.depositTypes = response.data['depositTypes'];

                if (response.data.hasOwnProperty('message') && response.data['message']) {
                    _this4.$refs['toastr'].i(response.data['message']);
                }

                setTimeout(function () {
                    _this4.loading = false;
                }, 500);
            }).catch(function () {
                _this4.$refs['toastr'].e('Произошла ошибка');
            });
        },
        calculateTotalAmount: function calculateTotalAmount(amount, interest) {
            var total = amount * interest / 100;

            return (total / 12).toFixed(2);
        },
        payOrder: function payOrder(orderId) {
            var message = 'Нет доступных систем оплаты.';
            this.$refs['toastr'].e(message);
        }
    }
});

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toastr__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_toastr__);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'payment',
    components: {
        'vue-toastr': __WEBPACK_IMPORTED_MODULE_0_vue_toastr___default.a
    },
    data: function data() {
        return {
            paymentSystems: [],
            selectedPaymentSystem: null,
            paymentForm: ''
        };
    },

    props: {
        orderId: {
            type: String,
            default: null
        }
    },
    mounted: function mounted() {
        this.loadPaymentSystems();
    },

    methods: {
        loadPaymentSystems: function loadPaymentSystems() {
            var _this = this;

            this.axios.get('finance/payment_systems').then(function (response) {
                _this.paymentSystems = response.data['payment_systems'];
            }).catch(function (error) {
                console.log(error);
            });
        },
        resetData: function resetData() {
            this.selectedPaymentSystem = null;
            this.paymentForm = '';
        },
        startPayment: function startPayment(paymentSystem) {
            var _this2 = this;

            this.selectedPaymentSystem = paymentSystem;
            this.paymentForm = '';
            this.$refs['toastr'].removeByType('error');

            if (!paymentSystem.active) {
                this.$refs['toastr'].e({
                    msg: 'Данная платежная система не&nbsp;доступна.',
                    timeout: 0
                });
                return;
            }

            this.axios.post('finance/payment_form', {
                order_id: this.orderId,
                payment_system: paymentSystem.id
            }).then(function (response) {
                _this2.paymentForm = response.data;
            }).catch(function (error) {
                if (error.response && error.response.data && error.response.data.hasOwnProperty('message')) {
                    _this2.$refs('vue-toastr').e(error.response.data['message']);
                } else {
                    _this2.$refs('vue-toastr').e('Произошла ошибка.');
                }
            });
        }
    }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"id":"paymentSystems","title":"Выбор платежной системы","ok-title":"Отмена","ok-only":true,"size":"lg"},on:{"hide":_vm.resetData}},[_c('b-card-group',{attrs:{"deck":""}},_vm._l((_vm.paymentSystems),function(paymentSystem){return _c('b-card',{key:"paymentSystem",class:{disabled: !paymentSystem.active, selected: (_vm.selectedPaymentSystem && _vm.selectedPaymentSystem.id === paymentSystem.id)},staticStyle:{"max-width":"129px"},attrs:{"overlay":"","no-body":"","img-src":paymentSystem.image,"img-alt":paymentSystem.title},on:{"click":function($event){_vm.startPayment(paymentSystem)}}})})),_vm._v(" "),_c('template',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[(_vm.selectedPaymentSystem)?_c('p',{staticClass:"mr-auto my-auto"},[_vm._v("Выбранная платежная система: "+_vm._s(_vm.selectedPaymentSystem.title))]):_vm._e(),_vm._v(" "),(!_vm.paymentForm)?_c('b-btn',{attrs:{"disabled":true}},[_vm._v("Продолжить")]):_c('div',{domProps:{"innerHTML":_vm._s(_vm.paymentForm)}})],1),_vm._v(" "),_c('vue-toastr',{ref:"toastr"})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('vue-toastr',{ref:"toastr"}),_vm._v(" "),_c('div',{class:{blur: _vm.loading}},[_c('b-row',[_c('b-col',[_c('h1',{staticClass:"mb-4"},[_vm._v("Депозиты")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b-card',{attrs:{"title":"Проценты по депозитам"}},[_c('b-row',_vm._l((['EUR', 'SPD']),function(currencyCode){return _c('b-col',{key:currencyCode},[_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Валюта")]),_vm._v(" "),_c('th',[_vm._v("Сумма")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("%")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.depositTypes[currencyCode]),function(depositType,index){return _c('tr',[(index == 0)?_c('td',{staticClass:"text-center align-middle font-weight-bold table-warning",attrs:{"rowspan":_vm.depositTypes[currencyCode].length}},[_vm._v(_vm._s(depositType.currency))]):_vm._e(),_vm._v(" "),(index == 0)?_c('td',{staticClass:"small"},[_vm._v("До "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatMoney(_vm.depositTypes[currencyCode][index+1].minimalAmount, depositType.currency, 0))}})]):(index == _vm.depositTypes[currencyCode].length - 1)?_c('td',{staticClass:"small"},[_vm._v("Свыше "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatMoney(depositType.minimalAmount, depositType.currency, 0))}})]):_c('td',{staticClass:"small"},[_vm._v("От "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatMoney(depositType.minimalAmount, depositType.currency, 0))}}),_c('br'),_vm._v("до "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatMoney(_vm.depositTypes[currencyCode][index+1].minimalAmount, depositType.currency, 0))}})]),_vm._v(" "),_c('td',{staticClass:"text-center font-weight-bold"},[_vm._v(_vm._s(depositType.interest)+"%")])])}))])])}))],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-card',{attrs:{"title":"Открыть депозит"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.openDeposit()}}},[_c('b-form-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b-form-group',{attrs:{"label":"Сумма вклада","label-for":"deposit-amount"}},[_c('b-form-input',{attrs:{"id":"deposit-amount","formatter":_vm.onlyDigits,"type":"number"},model:{value:(_vm.deposit.amount),callback:function ($$v) {_vm.deposit.amount=_vm._n($$v)},expression:"deposit.amount"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-group',{attrs:{"label":"Валюта","label-for":"deposit-currency"}},[_c('b-form-select',{attrs:{"id":"deposit-currency","options":_vm.currencies},model:{value:(_vm.deposit.currency),callback:function ($$v) {_vm.deposit.currency=$$v},expression:"deposit.currency"}})],1)],1)],1),_vm._v(" "),(_vm.isSPDSelected)?_c('p',{staticClass:"small text-danger"},[_c('b',[_vm._v("Внимание!")]),_vm._v(" Открытие депозита в SPD осуществляется только при прямой покупке SPD у Банка.")]):_vm._e(),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_c('i',{staticClass:"fa fa-shopping-cart"}),_vm._v("  Открыть\n                        ")]),_vm._v(" "),_c('h6',{staticClass:"mt-5"},[_vm._v("Рассчет")]),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b-form-group',{attrs:{"label":"Срок","label-for":"deposit-time"}},[_c('b-form-select',{attrs:{"id":"form-time","options":_vm.periods},model:{value:(_vm.deposit.period),callback:function ($$v) {_vm.deposit.period=$$v},expression:"deposit.period"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-group',{attrs:{"label":"Процент","label-for":"deposit-interest"}},[_c('b-form-input',{attrs:{"id":"deposit-interest","value":_vm.interest,"readonly":""}})],1)],1)],1),_vm._v(" "),_c('p',[_vm._v("Итого: "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatMoney(_vm.totalAmount, _vm.deposit.currency))}})])],1)],1)],1)],1),_vm._v(" "),(_vm.hasDepositOrders)?_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b-card',{attrs:{"title":"Мои депозиты"}},[_c('b-table',{attrs:{"stripped":"","hover":"","items":_vm.depositOrders,"fields":_vm.depositOrdersFields},scopedSlots:_vm._u([{key:"amount",fn:function(row){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatMoney(row.item.amount, row.item.currency))}})]}},{key:"period",fn:function(row){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.periodTitle(row.item.period))}})]}},{key:"total",fn:function(row){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatMoney(_vm.calculateTotalAmount(row.item.amount, row.item.interest), row.item.currency))}})]}},{key:"paid",fn:function(row){return [(!row.item.paid)?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.paymentSystems",modifiers:{"paymentSystems":true}}],attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.paymentOrderId = row.item.id}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Оплатить\n                            ")]):[_vm._v(_vm._s(row.item.paid))]]}}])})],1)],1)],1):_vm._e()],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('data-loading')],1):_vm._e(),_vm._v(" "),_c('modal-payment',{attrs:{"order-id":_vm.paymentOrderId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Credits_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d66a57_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Credits_vue__ = __webpack_require__(428);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Credits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d66a57_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Credits_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_toastr__);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'credits',
    components: {
        'data-loading': __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__["a" /* default */],
        'vue-toaster': __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default.a
    },
    data: function data() {
        return {
            loading: false,

            request: {
                lastname: '',
                firstname: '',
                email: '',
                skype: '',
                message: ''
            }
        };
    },

    computed: {
        formValid: function formValid() {
            return this.request.email && this.request.message;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.loading = true;
        setTimeout(function () {
            var user = _this.$store.state.user['userdata'];

            _this.request.lastname = user.lastname;
            _this.request.firstname = user.firstname;
            _this.request.email = user.email;
            _this.request.skype = user.skype;
            _this.request.message = '';

            _this.loading = false;
        }, 250);
    },

    methods: {
        sendRequest: function sendRequest() {
            var _this2 = this;

            this.loading = true;

            this.axios.post('credits/request', this.request).then(function (response) {
                if (response.data.hasOwnProperty('message') && response.data['message']) {
                    _this2.$refs['toastr'].i(response.data['message']);
                }
                _this2.request.message = '';
                _this2.loading = false;
            }).catch(function () {
                _this2.$refs['toastr'].e('Возникла ошибка');
                _this2.loading = false;
            });
        }
    }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('vue-toaster',{ref:"toastr"}),_vm._v(" "),_c('div',{class:{blur: _vm.loading}},[_c('b-row',[_c('b-col',[_c('h1',{staticClass:"mb-4"},[_vm._v("Система кредитования")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"8"}},[_c('b-card',{attrs:{"title":"Информация"}},[_c('p',[_vm._v("Кредиты выдаются под залог движимого и недвижимого имущества находящегося на Северном Кипре.")]),_vm._v(" "),_c('p',[_vm._v("В каждом случае мы подходим индивидуально - сумма кредита, процентная ставка, условия и сроки кредитования подбираются при рассмотрении заявки.")])])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-card',{attrs:{"title":"Оставить заявку"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.sendRequest()}}},[_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":"Фамилия","label-for":"profile-lastname"}},[_c('b-form-input',{attrs:{"id":"profile-lastname"},model:{value:(_vm.request.lastname),callback:function ($$v) {_vm.request.lastname=$$v},expression:"request.lastname"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"label":"Имя","label-for":"profile-firstname"}},[_c('b-form-input',{attrs:{"id":"profile-firstname"},model:{value:(_vm.request.firstname),callback:function ($$v) {_vm.request.firstname=$$v},expression:"request.firstname"}})],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"E-Mail","label-for":"profile-email"}},[_c('b-form-input',{attrs:{"id":"profile-email"},model:{value:(_vm.request.email),callback:function ($$v) {_vm.request.email=$$v},expression:"request.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Skype","label-for":"profile-skype"}},[_c('b-form-input',{attrs:{"id":"profile-skype"},model:{value:(_vm.request.skype),callback:function ($$v) {_vm.request.skype=$$v},expression:"request.skype"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Текст заявки","label-for":"message"}},[_c('b-form-textarea',{attrs:{"id":"message","palceholder":"Опишите под залог какого имущества Вы желаете получить кредит, на какой срок, на какую сумму расчитываете","rows":3,"max-rows":6},model:{value:(_vm.request.message),callback:function ($$v) {_vm.request.message=$$v},expression:"request.message"}})],1),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary","disabled":!_vm.formValid}},[_vm._v("Отправить")])],1)],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('data-loading')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Franchising_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c993857_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Franchising_vue__ = __webpack_require__(431);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Franchising_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c993857_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Franchising_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Payment_vue__ = __webpack_require__(115);






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Franchising',
    components: {
        'data-loading': __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading_vue__["a" /* default */],
        'vue-toastr': __WEBPACK_IMPORTED_MODULE_1_vue_toastr___default.a,
        'modal-payment': __WEBPACK_IMPORTED_MODULE_2__components_Payment_vue__["a" /* default */]
    },
    data: function data() {
        return {
            loading: false,
            paymentOrderId: null,

            marketingURL: 'static/marketing.pdf',
            marketingPage: 0,

            selectedFranchise: null,
            franchiseOrders: [],

            franchiseOrdersFields: {
                title: {
                    label: '',

                    tdClass: 'small'
                },
                date: {
                    label: 'Дата заказа',

                    tdClass: 'small'
                },
                paid: {
                    label: 'Покупка',

                    tdClass: 'small',
                    formatter: function formatter(value) {
                        if (value) {
                            return value;
                        }
                        return '';
                    }
                }
            }
        };
    },

    computed: {
        availableFranchises: function availableFranchises() {
            var franchises = [];

            franchises.push({ value: null, text: 'Выберите интересующую Вас франшизу', disabled: true });

            if (!this.$auth.user()['franchisee']) {
                franchises.push({ value: 'agent', text: 'Франшиза "Агент"' });
            }

            franchises.push({ value: 'supervisor', text: 'Франшиза "Супервайзер"' });

            return franchises;
        },
        hasFranchiseOrders: function hasFranchiseOrders() {
            return this.franchiseOrders.length > 0;
        }
    },
    mounted: function mounted() {
        this.loadFranchiseOrders();
    },

    methods: {
        loadFranchiseOrders: function loadFranchiseOrders() {
            var _this = this;

            this.loading = true;
            this.axios.get('franchising/franchise/orders').then(function (response) {
                _this.franchiseOrders = response.data['orders'];

                if (response.data.hasOwnProperty('message') && response.data['message']) {
                    _this.$refs['toastr'].i(response.data['message']);
                }

                setTimeout(function () {
                    _this.loading = false;
                }, 500);
            }).catch(function () {
                _this.$refs['toastr'].e('Произошла ошибка');
            });
        },
        orderFranchise: function orderFranchise() {
            var _this2 = this;

            this.axios.post('franchising/franchise/order', {
                franchise_type: this.selectedFranchise
            }).then(function (response) {
                var order = response.data['order'];

                var isNewOrder = true;
                _this2.franchiseOrders.forEach(function (oldOrder) {
                    if (oldOrder.id === order.id) {
                        isNewOrder = false;
                    }
                });
                if (isNewOrder) {
                    _this2.franchiseOrders.unshift(order);
                }

                if (response.data.hasOwnProperty('message') && response.data['message']) {
                    _this2.$refs['toastr'].i(response.data['message']);
                }

                _this2.payOrder(order.id);
            }).catch(function (error) {
                var message = 'Возникла ошибка';

                if (error.response) {
                    message = error.response.data['message'];
                } else if (error.request) {
                    message = 'Произошла ошибка обработки запроса';
                } else {
                    message = 'Произошла ошибка при отправке запроса';
                }

                _this2.$refs['toastr'].e(message);
            });
        },
        payOrder: function payOrder(orderId) {
            var message = 'Нет доступных систем оплаты.';
            this.$refs['toastr'].e(message);
        }
    }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('vue-toastr',{ref:"toastr"}),_vm._v(" "),_c('div',{class:{blur: _vm.loading}},[_c('b-row',[_c('b-col',[_c('h1',{staticClass:"mb-4"},[_vm._v("Франчайзинг")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"7"}},[_c('b-card',{attrs:{"title":"Описание"}},[_c('h6',[_vm._v("Франшиза \"Агент\"")]),_vm._v(" "),_c('p',[_vm._v("Официальное название статуса Дистрибьютора в статусе “Агент”. Стоимость франшизы “Агент” - € 100. Франшиза “Агент” дает право получать доходы от прямых продаж банковских услуг (депозитов) и процент от продаж услуг от двух уровней собственной агентской организации.")]),_vm._v(" "),_c('p',[_vm._v("Ежемесячное роялти (активация франшизы) составляет € 10.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("Франшиза \"Супервайзер\"")]),_vm._v(" "),_c('p',[_vm._v("Официальное название статуса Дистрибьютора в статусе “Супервайзер”. Стоимость франшизы “Супервайзер” - € 1000. Франшиза “Супервайзер” дает право получать доходы от:")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("прямых продаж банковских услуг (депозитов)")]),_vm._v(" "),_c('li',[_vm._v("процент от вознаграждений по депозитам двух уровней собственной агентской организации")]),_vm._v(" "),_c('li',[_vm._v("денежные вознаграждения и автобонус за создание большой агентской организации")])]),_vm._v(" "),_c('p',[_vm._v("Ежемесячное роялти (активация франшизы) составляет € 10.")])]),_vm._v(" "),_c('b-card',{attrs:{"title":"Маркетинговый план"}},[_c('p',[_vm._v("Более подробно со всеми возможностями франчайзи Вы можете ознакомиться в "),_c('a',{attrs:{"href":"static/marketing.pdf","target":"_blank"}},[_vm._v("Маркетинговом плане")]),_vm._v(".")])])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"5"}},[_c('b-card',{attrs:{"title":"Приобрести"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.orderFranchise($event)}}},[_c('b-form-group',{attrs:{"label":"Франшиза","label-for":"franchise-order-type"}},[_c('b-form-select',{attrs:{"options":_vm.availableFranchises},model:{value:(_vm.selectedFranchise),callback:function ($$v) {_vm.selectedFranchise=$$v},expression:"selectedFranchise"}})],1),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary","disabled":!_vm.selectedFranchise}},[_c('i',{staticClass:"fa fa-cart-plus"}),_vm._v("  Заказать\n                        ")])],1)],1),_vm._v(" "),(_vm.hasFranchiseOrders)?_c('b-card',{attrs:{"title":"Заказы"}},[_c('b-table',{attrs:{"stripped":"","hover":"","items":_vm.franchiseOrders,"fields":_vm.franchiseOrdersFields},scopedSlots:_vm._u([{key:"title",fn:function(row){return [_vm._v("\n                            "+_vm._s(row.item.title)),_c('br'),_vm._v("\n                            Стоимость: "+_vm._s(row.item.amount)+"\n                        ")]}},{key:"paid",fn:function(row){return [(!row.item.paid)?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.paymentSystems",modifiers:{"paymentSystems":true}}],attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.paymentOrderId = row.item.id}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Оплатить\n                            ")]):[_vm._v(_vm._s(row.item.paid))]]}}])})],1):_vm._e()],1)],1),_vm._v(" "),_c('modal-payment',{attrs:{"order-id":_vm.paymentOrderId}})],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('data-loading')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Franchisee_vue__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_588909f0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Franchisee_vue__ = __webpack_require__(434);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Franchisee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_588909f0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Franchisee_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Franchisee',
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.axios.get('').then(function (response) {
            console.log(response);
        }).catch(function (error) {
            console.log(error);
        });
    }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410b4650_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__ = __webpack_require__(437);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410b4650_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AdminOrdersList',
    data: function data() {
        return {
            orders: [],
            orderTypes: {
                deposit: 'на депозит',
                franchise: 'на франшизу'
            }
        };
    },
    mounted: function mounted() {
        this.loadOrdersList();
    },

    methods: {
        loadOrdersList: function loadOrdersList() {
            var _this = this;

            this.axios.get('admin/orders').then(function (response) {
                console.log(response.data);
                _this.orders = response.data.orders;
            });
        },
        setOrderPaid: function setOrderPaid(orderId) {
            this.axios.post('admin/orders/paid', {
                order: orderId
            }).then(function (response) {
                console.log(response.data);
            });
        }
    }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',_vm._l((_vm.orders),function(order){return _c('b-card',{key:order.id,attrs:{"title":'Заказ ' + _vm.orderTypes[order.type]}},[_c('p',[_vm._v("Контрагент: "+_vm._s(order.counterpart))]),_vm._v(" "),_c('p',[_vm._v("Дата заказа: "+_vm._s(order.date))]),_vm._v(" "),_c('p',[_vm._v("Сумма заказа: "+_vm._s(order.amount.amount)+" "),_c('small',[_vm._v(_vm._s(order.amount.currency))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.setOrderPaid(order.id)}}},[_vm._v("Оплачен")])],1)])}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de8f2a34_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(444);
function injectStyle (ssrContext) {
  __webpack_require__(439)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de8f2a34_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',
    data: function data() {
        return {
            credentials: {
                username: '',
                password: ''
            },
            isError: false,
            isChecking: false,
            errorCode: null
        };
    },

    computed: {
        disabled: function disabled() {
            return this.isChecking || !this.credentials.username || !this.credentials.password;
        },
        errorMessage: function errorMessage() {
            return this.errorCode;
        }
    },
    mounted: function mounted() {},

    methods: {
        login: function login() {
            var redirect = this.$auth.redirect();

            this.isChecking = true;

            this.$auth.login({
                data: __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(this.credentials),
                redirect: { name: redirect ? redirect.from.name : 'Dashboard' },
                fetchUser: true,
                success: function success() {
                    this.isChecking = false;
                    this.$router.push({ name: redirect ? redirect.from.name : 'Dashboard' });
                },
                error: function error(res) {
                    this.isChecking = false;
                    this.isError = true;
                    this.errorCode = res.response.data.message;
                    this.credentials.password = '';
                }
            });
        }
    }
});

/***/ }),
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('b-card-group',[_c('b-card',{staticClass:"p-4"},[_c('h1',{staticClass:"mb-3"},[_vm._v("Авторизация")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login()}}},[_c('div',{staticClass:"input-group mb-3"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-user"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.username),expression:"credentials.username"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Имя пользователя"},domProps:{"value":(_vm.credentials.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.credentials.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Пароль"},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.credentials.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{ref:"AuthLoginBtn",staticClass:"px-4",attrs:{"type":"submit","variant":"primary","disabled":_vm.disabled}},[_vm._v("Вход")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"6"}},[_c('b-link',{staticClass:"btn btn-link px-0",attrs:{"to":{name: 'AuthRemindPassword'}}},[_vm._v("Забыли пароль?")])],1)],1)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Ошибка авторизации","ok-only":true},model:{value:(_vm.isError),callback:function ($$v) {_vm.isError=$$v},expression:"isError"}},[_c('p',{attrs:{"clas":"my-4"}},[_vm._v(_vm._s(_vm.errorMessage))])])],1),_vm._v(" "),_c('b-card',{staticClass:"text-center",attrs:{"bg-variant":"primary"}},[_c('h3',{staticClass:"mt-3 mb-3"},[_vm._v("Регистрация")]),_vm._v(" "),_c('p',{staticClass:"pl-1 pr-1"},[_vm._v("Если Вы уже являетесь клиентом сервисов компании «Professional Group», то Вам не нужно проходить процедуру регистраци — Вы можете авторизоваться под своим логином/паролем из этих сервисов.")]),_vm._v(" "),_c('b-link',{staticClass:"btn btn-primary active mt-3",attrs:{"to":{name: 'AuthRegistration'},"router-tag":"button"}},[_vm._v("Зарегистрироваться")])],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('b-link',{staticClass:"btn btn-primary",attrs:{"to":{name: 'Frontend'}}},[_vm._v("На главную")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoLogin_vue__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ab1a486_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AutoLogin_vue__ = __webpack_require__(448);
function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AutoLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ab1a486_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AutoLogin_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading__ = __webpack_require__(16);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'auth-autologin',
    data: function data() {
        return {};
    },

    components: {
        'data-loading': __WEBPACK_IMPORTED_MODULE_0__containers_DataLoading__["a" /* default */]
    },
    mounted: function mounted() {
        var _this = this;

        this.axios.get('auth/autologin/' + this.$route.params['token']).then(function (response) {
            _this.$auth.token(null, response.data['token']);

            _this.$router.push({ name: 'Cabinet' });
        }).catch(function () {});
    }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('data-loading')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59340b46_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(451);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59340b46_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'logout',
    created: function created() {
        this.$auth.logout();
    }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Logging out...")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ab505cc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__ = __webpack_require__(458);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ab505cc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Register',
    data: function data() {
        return {
            registration: {
                lastname: '',
                firstname: '',
                email: ''
            },
            isFormSubmitted: false,
            isRegistrationError: false,
            registrationErrorMessage: '',
            validationErrors: {
                firstname: false,
                lastname: false,
                email: false
            },

            isRegistrationSuccess: false,
            registrationSuccessMessage: '',

            isProcessing: false
        };
    },

    computed: {
        isRegistrationFormValid: function isRegistrationFormValid() {
            return this.registration.lastname && this.registration.firstname && this.isEmailValid;
        },
        isEmailValid: function isEmailValid() {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(this.registration.email);
        }
    },
    methods: {
        startRegistration: function startRegistration() {
            var _this = this;

            this.isFormSubmitted = true;

            this.registrationErrorMessage = '';
            this.isRegistrationError = false;
            this.validationErrors = {
                firstname: false,
                lastname: false,
                email: false
            };

            this.isProcessing = true;

            this.axios.post('/auth/registration/start', this.registration).then(function (response) {
                if (response.data.hasOwnProperty('message')) {
                    _this.isRegistrationSuccess = true;
                    _this.registrationSuccessMessage = response.data.message;
                }

                _this.isProcessing = false;
            }).catch(function (error) {
                var response = error.response.data;
                if (response.hasOwnProperty('message')) {
                    _this.registrationErrorMessage = response.message;
                    _this.isRegistrationError = true;
                }

                _this.isProcessing = false;

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.errors).map(function (field) {
                    var fieldErrors = response.errors[field];
                    _this.validationErrors[field] = fieldErrors;
                    console.log(fieldErrors);
                });
            });
        }
    }
});

/***/ }),
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('b-card',{staticClass:"mx-4",attrs:{"hidden":""}},[_c('p',[_vm._v("Прямая регистрация временно не доступна. Для доступа в личный кабинет необходимо зарегистрироваться в "),_c('a',{attrs:{"href":"http://world-union.biz","target":"_blank"}},[_vm._v("Ассоциации Интернет-Предпринимателей")]),_vm._v(" или в "),_c('a',{attrs:{"href":"http://spooo.ru","target":"_blank"}},[_vm._v("Социальной сети Spooo.biz")]),_vm._v(", после чего авторизоваться с полученными логином/паролем в Profi-Bank")])]),_vm._v(" "),_c('div',{staticClass:"card mx-4"},[_c('div',{staticClass:"card-body p-4"},[_c('form',{attrs:{"autocomplete":"on"},on:{"submit":function($event){$event.preventDefault();_vm.startRegistration($event)}}},[_c('h1',[_vm._v("Регистрация")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Укажите свои имя и email-адрес")]),_vm._v(" "),_c('b-form-group',{staticClass:"mb-0"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-user"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registration.firstname),expression:"registration.firstname"}],staticClass:"form-control",class:{'is-invalid': _vm.validationErrors.firstname, 'is-valid': _vm.isFormSubmitted && !_vm.validationErrors.firstname},attrs:{"type":"text","placeholder":"Имя"},domProps:{"value":(_vm.registration.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registration.firstname=$event.target.value}}})]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled form-text text-danger mb-0",class:{'d-none': !_vm.validationErrors.firstname},staticStyle:{"margin-left":"40px"}},_vm._l((_vm.validationErrors.firstname),function(error){return _c('li',[_c('small',[_vm._v(_vm._s(error))])])}))]),_vm._v(" "),_c('b-form-group',{staticClass:"mb-0"},[_c('div',{staticClass:"input-group mt-3"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-user"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registration.lastname),expression:"registration.lastname"}],staticClass:"form-control",class:{'is-invalid': _vm.validationErrors.lastname, 'is-valid': _vm.isFormSubmitted && !_vm.validationErrors.lastname},attrs:{"type":"text","placeholder":"Фамилия"},domProps:{"value":(_vm.registration.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registration.lastname=$event.target.value}}})]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled form-text text-danger mb-0",class:{'d-none': !_vm.validationErrors.lastname},staticStyle:{"margin-left":"40px"}},_vm._l((_vm.validationErrors.lastname),function(error){return _c('li',[_c('small',[_vm._v(_vm._s(error))])])}))]),_vm._v(" "),_c('b-form-group',{staticClass:"mb-0"},[_c('div',{staticClass:"input-group mt-3"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("@")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registration.email),expression:"registration.email"}],staticClass:"form-control",class:{'is-invalid': _vm.validationErrors.email, 'is-valid': _vm.isFormSubmitted && !_vm.validationErrors.email},attrs:{"type":"email","placeholder":"E-Mail"},domProps:{"value":(_vm.registration.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.registration.email=$event.target.value}}})]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled form-text text-danger mb-0",class:{'d-none': !_vm.validationErrors.email},staticStyle:{"margin-left":"40px"}},_vm._l((_vm.validationErrors.email),function(error){return _c('li',[_c('small',[_vm._v(_vm._s(error))])])}))]),_vm._v(" "),_c('p',{staticClass:"text-danger small mt-3"},[_c('small',[_vm._v("При регистрации Вы автоматически подтверждаете свое "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.agreement",modifiers:{"agreement":true}}],staticClass:"text-danger",attrs:{"href":"#agreement"},on:{"click":function($event){$event.preventDefault();}}},[_vm._v("согласие на обработку персональных данных")]),_vm._v(".")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-primary",attrs:{"type":"submit","disabled":!_vm.isRegistrationFormValid || _vm.isProcessing}},[_vm._v("Продолжить")])],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"agreement","title":"Согласие на обработку персональных данных","size":"lg","ok-only":true}},[_c('p',[_vm._v("В соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных», я свободно, своей волей и в своем интересе даю согласие на осуществление «Profi Bank» (далее – Банк), обработки указанных в настоящем обращении моих персональных данных (сбора, записи, систематизации, накопления, хранения, уточнения (обновления, изменения), извлечения, использования, передачи, обезличивания, блокирования и уничтожения) с использованием/без использования средств автоматизации в целях обработки настоящего электронного обращения и направления/ предоставления ответа.")]),_vm._v(" "),_c('p',[_vm._v("Согласие предоставляется с момента оформления настоящего обращения и действительно в течение срока, предусмотренного действующим законодательством Российской Федерации.")]),_vm._v(" "),_c('p',[_vm._v("Я уведомлен(-на), что согласие на обработку персональных данных может быть отозвано в соответствии с ч. 2 ст. 9 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных». В случае отзыва согласия на обработку персональных данных Банк вправе продолжить обработку персональных данных без моего согласия при наличии оснований, указанных в п. 2-11 ч. 1 ст. 6, ч. 2 ст. 10, ч. 2 ст. 11 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».")]),_vm._v(" "),_c('p',[_vm._v("Согласен(-на) с тем, что Банк в целях уточнения информации, содержащейся в обращении, и информирования о ходе рассмотрения настоящего обращения может использовать сведения, содержащиеся в настоящем электронном обращении.")]),_vm._v(" "),_c('p',[_vm._v("Банк доводит Вашего сведения, что электронные обращения, направленные через сеть Интернет, передаются по незащищенным каналам связи. Банк не несет ответственности за сохранение конфиденциальности данных при их передаче через сеть Интернет.")])])],1)]),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Ошибка","ok-only":true},model:{value:(_vm.isRegistrationError),callback:function ($$v) {_vm.isRegistrationError=$$v},expression:"isRegistrationError"}},[_c('div',{staticClass:"my-4",domProps:{"innerHTML":_vm._s(_vm.registrationErrorMessage)}})]),_vm._v(" "),_c('b-modal',{staticClass:"modal-success",attrs:{"title":"Сообщение","ok-only":true,"ok-variant":"success"},model:{value:(_vm.isRegistrationSuccess),callback:function ($$v) {_vm.isRegistrationSuccess=$$v},expression:"isRegistrationSuccess"}},[_c('div',{staticClass:"my-4",domProps:{"innerHTML":_vm._s(_vm.registrationSuccessMessage)}})])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('b-link',{staticClass:"btn btn-primary",attrs:{"to":{name: 'AuthLogin'}}},[_vm._v("Авторизация")]),_vm._v(" "),_c('b-link',{staticClass:"btn btn-primary",attrs:{"to":{name: 'Frontend'}}},[_vm._v("На главную")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemindPassword_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd1ccda_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_RemindPassword_vue__ = __webpack_require__(461);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemindPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd1ccda_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_RemindPassword_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RemindPassword'
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05606270_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__ = __webpack_require__(464);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05606270_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'confirm-registration',

    data: function data() {
        return {
            registration: {
                firstname: '',
                lastname: '',
                email: '',
                username: '',
                password: '',
                password2: ''
            },

            isProcessing: false,

            isRegistrationError: false,
            registrationErrorMessage: ''
        };
    },


    computed: {
        feedbackUsername: function feedbackUsername() {
            var expr = /^[a-zA-Z]+[a-zA-Z0-9-]*$/;
            if (!this.registration.username.match(expr)) {
                return '<small>Логин должен содержать только латинские буквы, цифры, символ "-" и начинаться с буквы</small>';
            }

            if (this.registration.username.length < 5) {
                return '<small>Логин должен быть длиной минимум 5 символов</small>';
            }

            return '';
        },
        feedbackPassword: function feedbackPassword() {
            var expr1 = /[!@#$%;:^&*()_+-=|\\]/;
            var expr2 = /[0-9]/;
            var expr3 = /[А-ЯA-Z]/;

            if (!expr1.test(this.registration.password) || !expr2.test(this.registration.password) || !expr3.test(this.registration.password)) {
                return '<small>Пароль должен содержать как минимум один специальный символ, одну цифру и одну большую букву</small>';
            }

            if (this.registration.password.length < 8) {
                return '<small>Длина пароля должна быть не менее 8 символов</small>';
            }

            return '';
        },
        isValidUsername: function isValidUsername() {
            return this.feedbackUsername === '';
        },
        isValidPassword: function isValidPassword() {
            return this.feedbackPassword === '';
        },
        isValidPassword2: function isValidPassword2() {
            return this.registration.password === this.registration.password2;
        }
    },

    mounted: function mounted() {
        var _this = this;

        var token = this.$route.params['token'];

        this.axios.post('auth/registration/confirmation', {
            token: token
        }).then(function (response) {
            var data = response.data['registration_data'];
            _this.registration.lastname = data['surname'];
            _this.registration.firstname = data['name'];
            _this.registration.email = data['email'];

            _this.$emit('dataLoaded');
        }).catch(function (error) {
            console.log(error);
        });
    },


    methods: {
        finishRegistration: function finishRegistration() {
            var _this2 = this;

            this.isProcessing = true;
            this.axios.post('/auth/registration/finish', {
                username: this.registration.username,
                password: this.registration.password,
                token: this.$route.params['token']
            }).then(function (response) {
                _this2.$router.push({ name: 'AuthLogin' });
            }).catch(function (error) {
                var response = error.response.data;
                if (response.hasOwnProperty('message')) {
                    _this2.registrationErrorMessage = response.message;
                    _this2.isRegistrationError = true;
                }

                _this2.isProcessing = false;
            });
        }
    }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col'),_vm._v(" "),_c('b-col',{attrs:{"cols":"8"}},[_c('b-card',{attrs:{"title":"Регистрация","sub-title":"Завершение регистрации"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.finishRegistration($event)}}},[_c('b-form-row',[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":"Имя"}},[_c('b-form-input',{attrs:{"readonly":""},model:{value:(_vm.registration.firstname),callback:function ($$v) {_vm.registration.firstname=$$v},expression:"registration.firstname"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-group',{attrs:{"label":"Фамилия"}},[_c('b-form-input',{attrs:{"readonly":""},model:{value:(_vm.registration.lastname),callback:function ($$v) {_vm.registration.lastname=$$v},expression:"registration.lastname"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label":"E-Mail"}},[_c('b-form-input',{attrs:{"readonly":""},model:{value:(_vm.registration.email),callback:function ($$v) {_vm.registration.email=$$v},expression:"registration.email"}})],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Логин","feedback":_vm.feedbackUsername,"state":_vm.isValidUsername}},[_c('b-form-input',{attrs:{"placeholder":"Придумайте интересный логин (минимум 5 символов)"},model:{value:(_vm.registration.username),callback:function ($$v) {_vm.registration.username=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"registration.username"}})],1),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Пароль","feedback":_vm.feedbackPassword,"state":_vm.isValidPassword}},[_c('b-form-input',{attrs:{"type":"password","placeholder":"Укажите пароль"},model:{value:(_vm.registration.password),callback:function ($$v) {_vm.registration.password=$$v},expression:"registration.password"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"label":"&nbsp;","feedback":"<small>Введенные пароли не совпадают</small>","state":_vm.isValidPassword2}},[_c('b-form-input',{attrs:{"type":"password","placeholder":"Повторите пароль еще раз"},model:{value:(_vm.registration.password2),callback:function ($$v) {_vm.registration.password2=$$v},expression:"registration.password2"}})],1)],1)],1),_vm._v(" "),_c('b-btn',{attrs:{"type":"submit","variant":"primary","disabled":!(_vm.isValidUsername && _vm.isValidPassword && _vm.isValidPassword2) || _vm.isProcessing}},[_vm._v("Завершить")])],1)],1),_vm._v(" "),_c('b-modal',{staticClass:"modal-danger",attrs:{"title":"Ошибка","ok-only":true},model:{value:(_vm.isRegistrationError),callback:function ($$v) {_vm.isRegistrationError=$$v},expression:"isRegistrationError"}},[_c('div',{staticClass:"my-4",domProps:{"innerHTML":_vm._s(_vm.registrationErrorMessage)}})])],1),_vm._v(" "),_c('b-col')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_user__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_finance__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_registration__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    modules: {
        user: __WEBPACK_IMPORTED_MODULE_4__modules_user__["a" /* default */],
        finance: __WEBPACK_IMPORTED_MODULE_5__modules_finance__["a" /* default */],
        registration: __WEBPACK_IMPORTED_MODULE_6__modules_registration__["a" /* default */]
    },
    strict: debug,
    plugins: debug ? [__WEBPACK_IMPORTED_MODULE_7_vuex_dist_logger___default()()] : []
}));

/***/ }),
/* 466 */,
/* 467 */
/***/ (function(module, exports) {



/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userdata", function() { return userdata; });
var userdata = function userdata(state) {
    return state.user.userdata;
};

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_user__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(58);



var _mutations;






var state = {
    userdata: {
        id: '',
        username: '',
        lastname: '',
        firstname: '',
        email: ''
    },
    roles: {
        admin: false,
        franchisee: false
    },
    notifications: []
};

var getters = {
    isAdmin: function isAdmin(state) {
        return state.roles.admin;
    },
    isFranchisee: function isFranchisee(state) {
        return state.roles.franchisee;
    }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutations__["c" /* USER_INIT_USERDATA */], function (state, id) {
    state.userdata.id = id;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutations__["e" /* USER_REFRESH_USERDATA */], function (state, userdata) {
    if (state.userdata.username !== userdata.username) state.userdata.username = userdata.username;
    if (state.userdata.lastname !== userdata.lastname) state.userdata.lastname = userdata.lastname;
    if (state.userdata.firstname !== userdata.firstname) state.userdata.firstname = userdata.firstname;
    if (state.userdata.email !== userdata.email) state.userdata.email = userdata.email;

    if (state.roles.admin !== userdata.admin) state.roles.admin = userdata.admin;
    if (state.roles.franchisee !== userdata.franchisee) state.roles.franchisee = userdata.franchisee;

    var auth = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].auth.user());
    auth.roles = [];

    if (state.roles.admin) {
        auth.roles.push('admin');
    }
    if (state.roles.franchisee) {
        auth.roles.push('franchisee');
    }
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].auth.user(auth);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutations__["d" /* USER_REFRESH_NOTIFICATIONS */], function (state, notifications) {
    state.notifications = notifications;
}), _mutations);

var actions = {
    initUserdata: function initUserdata(_ref, id) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["c" /* USER_INIT_USERDATA */], id);
    },
    refreshUserdata: function refreshUserdata(_ref2) {
        var commit = _ref2.commit;

        __WEBPACK_IMPORTED_MODULE_3__api_user__["a" /* default */].loadUserdata(function (userdata) {
            commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["e" /* USER_REFRESH_USERDATA */], userdata);
        });
    },
    refreshNotifications: function refreshNotifications(_ref3) {
        var commit = _ref3.commit;

        __WEBPACK_IMPORTED_MODULE_3__api_user__["a" /* default */].loadNotifications(function (notifications) {
            commit(__WEBPACK_IMPORTED_MODULE_4__mutations__["d" /* USER_REFRESH_NOTIFICATIONS */], notifications);
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var user = {
    loadUserdata: function loadUserdata(updateUserdata) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get('users/userdata').then(function (response) {
            var userdata = response.data['userdata'];
            updateUserdata(userdata);
        });
    },
    loadNotifications: function loadNotifications(updateNotifications) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get('users/notifications').then(function (response) {
            var notifications = response.data['notifications'];
            updateNotifications(notifications);
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_finance__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_mutations__ = __webpack_require__(58);





var state = {
    rate: 0
};

var getters = {};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__store_mutations__["a" /* FINANCE_REFRESH_RATE */], function (state, rate) {
    state.rate = rate;
});

var actions = {
    refreshRate: function refreshRate(_ref) {
        var commit = _ref.commit;

        __WEBPACK_IMPORTED_MODULE_1__api_finance__["a" /* default */].loadRate(function (rate) {
            commit(__WEBPACK_IMPORTED_MODULE_2__store_mutations__["a" /* FINANCE_REFRESH_RATE */], rate);
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);


var finance = {
    loadRate: function loadRate(updateRate) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get('finance/refresh/rate').then(function (response) {
            var rate = response.data['rate'];
            updateRate(rate);
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = (finance);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutations__ = __webpack_require__(58);





var state = {
    token: '',
    email: '',
    firstname: '',
    lastname: '',
    referrer_auth_id: null,
    process: false
};

var getters = {};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__store_mutations__["b" /* REGISTRATION_FILL_DATA */], function (state, data) {
    state.email = data.email;
    state.firstname = data.name;
    state.lastname = data.surname;
    state.referrer_auth_id = data.referrer_auth_id;
    state.token = data.key;
    state.process = true;
});

var actions = {
    fillRegistrationData: function fillRegistrationData(_ref, data) {
        var commit = _ref.commit;

        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutations__["b" /* REGISTRATION_FILL_DATA */], data);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ })
],[118]);


// WEBPACK FOOTER //
// static/js/app.08933a6d90de97f113bd.js